/*! sm-framleidsla.js 1.2.1 - Skilti og merkingar. Production SVG for xTool Creative Space
 * (mm, layers by colour, text as outlines) for every order line. ES5, window.SMFram.
 * Loads sm-opentype.min.js (opentype.js 1.3.4, MIT), sm-clipper.min.js (Clipper 6.4.2, Boost)
 * and the font assets sm-letur-<id>.json (OFL fonts, WOFF bytes as base64) and
 * sm-letur-rounded-elegance-open.js (MyFonts webfont) lazily, only when a file is built.
 * API: see kjarni.md.
 */
(function (W, D) {
  'use strict';
  if (!W || W.SMFram) return;

  var UTGAFA = '1.2.1';
  var SNID = 'SMF1';
  var SC = 1e5;          /* clipper integer scale: 1 unit = 0.00001 mm */
  var TOL = 0.01;        /* curve flattening: d1 + d2 <= TOL, so a chord is at most 0.75 x TOL = 0.0075 mm off the curve */
  var EINF = 1;          /* polygon simplification (Douglas-Peucker) in 0.01 mm: 0.01 mm. With the 0.01 mm grid the written
                          * outline stays within 0.02 mm of the exact curves (measured at most 0.017 mm) */
  var TIMI = 2500;       /* default time budget for one file, ms */
  var SENDA_TIMI = 8000; /* the add with the file must answer within this, ms (SMFram.senda) */
  var SENDA_NAAD = 4000; /* extra wait when the whole file is already uploaded and Shopify is working, ms */
  var ENDUR_TIMI = 15000;/* the add again without the file, ms */
  var KARFA_TIMI = 5000; /* one /cart.js check, ms */
  var HAMARK_JSON = 30000;
  var SKRA_LYKILL = '_Framlei\u00f0sluskr\u00e1';   /* hidden file property, as tested in the cart 2026-09-27 */
  var JSON_LYKILL = '_framleidsla';
  var NR_LYKILL = '_framleidsla_nr';   /* unique per added line with a file: finds the line in /cart.js after a lost answer */

  /* Layers in file order. GRAFA, SKERA-INNRA and SKERA-YTRA are unioned (nonzero).
   * 1.2.0: the engraved metal frame (steel and brass on the F1 Ultra) in two fill layers, written as
   * native rects that never overlap: RAMMI-LARETT (top and bottom, full width, filled at 0 degrees) and
   * RAMMI-LODRETT-90 (the sides between them, filled at 90 degrees). The workshop app reads them by id. */
  var LOG_ROD = ['GRAFA-MYND', 'GRAFA', 'RAMMI-LARETT', 'RAMMI-LODRETT-90', 'LINA', 'SKERA-INNRA', 'SKERA-YTRA', 'UTLINA'];
  var SAMEINA = { 'GRAFA': 1, 'SKERA-INNRA': 1, 'SKERA-YTRA': 1 };
  var ATTR = {
    'GRAFA': 'fill="#000000" fill-rule="nonzero" stroke="none"',
    'RAMMI': 'fill="#000000" fill-rule="nonzero" stroke="none"',
    'LINA': 'fill="none" stroke="#0000ff" stroke-width="0.1"',
    'SKERA': 'fill="none" stroke="#ff0000" stroke-width="0.1"',
    'UTLINA': 'fill="none" stroke="#00b050" stroke-width="0.1"'
  };

  /* Font registry. skra = theme asset. OFL fonts: sm-letur-<id>.json = {"b64": WOFF bytes} (the WOFF is
   * built by scripts/framleidsla-kjarni/letur_prep.py: static instance, Latin + Icelandic + Polish subset;
   * the JSON by letur_json.py). JSON, because Shopify's CDN serves theme .woff assets as WOFF2 (which
   * opentype.js cannot read) but serves .json assets byte for byte. virkt:false = no file in the theme. */
  var GF = 'google/fonts ofl/';
  var LETUR = {
    'montserrat-400': { f: 'Montserrat', w: 400, u: GF + 'montserrat/Montserrat[wght].ttf Version 9.000' },
    'montserrat-500': { f: 'Montserrat', w: 500, u: GF + 'montserrat/Montserrat[wght].ttf Version 9.000' },
    'montserrat-600': { f: 'Montserrat', w: 600, u: GF + 'montserrat/Montserrat[wght].ttf Version 9.000' },
    'montserrat-700': { f: 'Montserrat', w: 700, u: GF + 'montserrat/Montserrat[wght].ttf Version 9.000' },
    'montserrat-900': { f: 'Montserrat', w: 900, u: GF + 'montserrat/Montserrat[wght].ttf Version 9.000' },
    'dancingscript-600': { f: 'Dancing Script', a: 'SM Skrift', w: 600, u: GF + 'dancingscript/DancingScript[wght].ttf Version 2.001' },
    'dancingscript-700': { f: 'Dancing Script', a: 'SM Skrift', w: 700, u: GF + 'dancingscript/DancingScript[wght].ttf Version 2.001' },
    'cormorantgaramond-500': { f: 'Cormorant Garamond', w: 500, u: GF + 'cormorantgaramond/CormorantGaramond[wght].ttf Version 4.001' },
    'cormorantgaramond-600': { f: 'Cormorant Garamond', w: 600, u: GF + 'cormorantgaramond/CormorantGaramond[wght].ttf Version 4.001' },
    'jost-400': { f: 'Jost', w: 400, u: GF + 'jost/Jost[wght].ttf Version 3.710' },
    'jost-500': { f: 'Jost', w: 500, u: GF + 'jost/Jost[wght].ttf Version 3.710' },
    'outfit-400': { f: 'Outfit', w: 400, u: GF + 'outfit/Outfit[wght].ttf Version 1.100' },
    'outfit-500': { f: 'Outfit', w: 500, u: GF + 'outfit/Outfit[wght].ttf Version 1.100' },
    'outfit-800': { f: 'Outfit', w: 800, u: GF + 'outfit/Outfit[wght].ttf Version 1.100' },
    'ebgaramond-500': { f: 'EB Garamond', w: 500, u: GF + 'ebgaramond/EBGaramond[wght].ttf Version 1.003' },
    'ebgaramond-italic-500': { f: 'EB Garamond', w: 500, i: 1, u: GF + 'ebgaramond/EBGaramond-Italic[wght].ttf Version 1.003' },
    'nunito-700': { f: 'Nunito', w: 700, u: GF + 'nunito/Nunito[wght].ttf Version 3.602' },
    'nunito-800': { f: 'Nunito', w: 800, u: GF + 'nunito/Nunito[wght].ttf Version 3.602' },
    'nunitosans-600': { f: 'Nunito Sans', w: 600, u: GF + 'nunitosans/NunitoSans[YTLC,opsz,wdth,wght].ttf Version 3.101 (opsz 12)' },
    'nunitosans-800': { f: 'Nunito Sans', w: 800, u: GF + 'nunitosans/NunitoSans[YTLC,opsz,wdth,wght].ttf Version 3.101 (opsz 12)' },
    'fraunces-italic-300': { f: 'Fraunces', w: 300, i: 1, u: GF + 'fraunces/Fraunces-Italic[SOFT,WONK,opsz,wght].ttf Version 1.000 (opsz 13.5)' },
    /* MyFonts webfont licence (bought 2026-09-27): the kit's font.woff unmodified, in a .js asset that
     * starts with the kit's @license notice. House and room numbers. */
    'rounded-elegance-open': { f: 'Rounded Elegance Open', w: 400, u: 'MyFonts webfont kit, Build ID 3867246, Rounded Elegance Open Regular by Douglas Charles', skra: 'sm-letur-rounded-elegance-open.js' }
  };
  (function () { for (var k in LETUR) if (LETUR.hasOwnProperty(k)) { if (!LETUR[k].skra) LETUR[k].skra = 'sm-letur-' + k + '.json'; if (LETUR[k].u.indexOf(GF) === 0) LETUR[k].gf = 1; } })();

  /* Google Fonts serves each family as separate files per unicode-range (latin, latin-ext, vietnamese,
   * ...). The browser shapes each file's run on its own, so there is no kerning or ligature across a
   * boundary (e.g. "\u0141u" in "\u0141ukasz"). Same rule here for gf fonts, so the file matches the preview. */
  var GF_SVID = [
    [[0x0, 0xFF], [0x131, 0x131], [0x152, 0x153], [0x2BB, 0x2BC], [0x2C6, 0x2C6], [0x2DA, 0x2DA], [0x2DC, 0x2DC], [0x304, 0x304], [0x308, 0x308], [0x329, 0x329], [0x2000, 0x206F], [0x20AC, 0x20AC], [0x2122, 0x2122], [0x2191, 0x2191], [0x2193, 0x2193], [0x2212, 0x2212], [0x2215, 0x2215], [0xFEFF, 0xFEFF], [0xFFFD, 0xFFFD]],
    [[0x100, 0x2BA], [0x2BD, 0x2C5], [0x2C7, 0x2CC], [0x2CE, 0x2D7], [0x2DD, 0x2FF], [0x1D00, 0x1DBF], [0x1E00, 0x1E9F], [0x1EF2, 0x1EFF], [0x2020, 0x2020], [0x20A0, 0x20AB], [0x20AD, 0x20C0], [0x2113, 0x2113], [0x2C60, 0x2C7F], [0xA720, 0xA7FF]],
    [[0x300, 0x301], [0x303, 0x304], [0x308, 0x309], [0x323, 0x323], [0x329, 0x329], [0x1EA0, 0x1EF9], [0x20AB, 0x20AB]]
  ];
  function gfSvid(c) {
    var u = c.charCodeAt(0);
    if (u >= 0xD800 && u <= 0xDBFF && c.length > 1) u = (u - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00) + 0x10000;
    for (var k = 0; k < GF_SVID.length; k++) for (var i = 0; i < GF_SVID[k].length; i++) if (u >= GF_SVID[k][i][0] && u <= GF_SVID[k][i][1]) return k + 1;
    return 9;
  }

  /* ---------------------------------------------------------------- small helpers */
  function nu() { return (W.performance && W.performance.now) ? W.performance.now() : new Date().getTime(); }
  function villa(kodi, texti) { var e = new Error('SMFram ' + kodi + (texti ? ': ' + texti : '')); e.kodi = kodi; return e; }
  function tala(v) { return typeof v === 'number' && isFinite(v); }
  function f3(n) { var v = Math.round(n * 1000) / 1000; if (v === 0) v = 0; return String(v); }
  /* drops characters XML 1.0 does not allow (control characters, lone surrogates, U+FFFE/FFFF) */
  function hreinsa(s) {
    s = String(s == null ? '' : s).replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\ufffe\uffff]/g, '');
    var out = '', i, c, d;
    for (i = 0; i < s.length; i++) {
      c = s.charCodeAt(i);
      if (c >= 0xD800 && c <= 0xDBFF) { d = s.charCodeAt(i + 1); if (d >= 0xDC00 && d <= 0xDFFF) { out += s.charAt(i) + s.charAt(i + 1); i++; } continue; }
      if (c >= 0xDC00 && c <= 0xDFFF) continue;
      out += s.charAt(i);
    }
    return out;
  }
  function escXml(s) { return hreinsa(s).replace(/[<>&"]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; }); }
  function escAthugasemd(s) { return hreinsa(s).replace(/[\r\n]+/g, ' / ').replace(/-{2,}/g, function (m) { return m.split('').join(' '); }).replace(/-$/, '- '); }
  function nfc(s) { s = String(s == null ? '' : s); try { if (s.normalize) s = s.normalize('NFC'); } catch (e) { } return s; }
  function afrita(o) { return JSON.parse(JSON.stringify(o)); }

  var SERSTAFIR = { '\u00f0': 'd', '\u00d0': 'd', '\u00fe': 'th', '\u00de': 'th', '\u00e6': 'ae', '\u00c6': 'ae', '\u00f8': 'o', '\u00d8': 'o', '\u0142': 'l', '\u0141': 'l', '\u00df': 'ss', '\u0153': 'oe', '\u0152': 'oe', '\u0111': 'd', '\u0110': 'd', '\u0131': 'i' };
  function ascii(s) {
    s = String(s == null ? '' : s).replace(/[\u00f0\u00d0\u00fe\u00de\u00e6\u00c6\u00f8\u00d8\u0142\u0141\u00df\u0153\u0152\u0111\u0110\u0131]/g, function (c) { return SERSTAFIR[c]; });
    try { if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { }
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function kodapunktar(s) {
    var out = [], i = 0, c, d;
    while (i < s.length) {
      c = s.charCodeAt(i);
      if (c >= 0xD800 && c <= 0xDBFF && i + 1 < s.length) { d = s.charCodeAt(i + 1); if (d >= 0xDC00 && d <= 0xDFFF) { out.push(s.substr(i, 2)); i += 2; continue; } }
      out.push(s.charAt(i)); i++;
    }
    return out;
  }
  var OSYNILEGIR = /[\u00ad\u034f\u061c\u115f\u1160\u17b4\u17b5\u180e\u200b-\u200f\u202a-\u202e\u2060-\u2064\ufe00-\ufe0f\ufeff]/;
  var BIL = /[\s\u00a0\u2000-\u200a\u202f\u205f\u3000]/;

  /* ---------------------------------------------------------------- 2D matrices [a,b,c,d,e,f] */
  function mul(a, b) {
    return [a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1], a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3],
      a[0] * b[4] + a[2] * b[5] + a[4], a[1] * b[4] + a[3] * b[5] + a[5]];
  }
  function fylki(s) {
    var m = [1, 0, 0, 1, 0, 0];
    if (!s) return m;
    if (typeof s !== 'string') return (s.length === 6) ? s.slice() : m;
    var re = /(matrix|translate|scale|rotate|skewX|skewY)\s*\(([^)]*)\)/g, r, v, t, a, cs, sn;
    while ((r = re.exec(s))) {
      v = r[2].split(/[\s,]+/).filter(function (x) { return x !== ''; }).map(Number);
      if (r[1] === 'matrix') t = v;
      else if (r[1] === 'translate') t = [1, 0, 0, 1, v[0], v[1] || 0];
      else if (r[1] === 'scale') t = [v[0], 0, 0, v[1] == null ? v[0] : v[1], 0, 0];
      else if (r[1] === 'rotate') {
        a = v[0] * Math.PI / 180; cs = Math.cos(a); sn = Math.sin(a); t = [cs, sn, -sn, cs, 0, 0];
        if (v.length > 2) t = mul(mul([1, 0, 0, 1, v[1], v[2]], t), [1, 0, 0, 1, -v[1], -v[2]]);
      } else if (r[1] === 'skewX') t = [1, 0, Math.tan(v[0] * Math.PI / 180), 1, 0, 0];
      else t = [1, Math.tan(v[0] * Math.PI / 180), 0, 1, 0, 0];
      m = mul(m, t);
    }
    return m;
  }
  function erEining(m) { return !m || (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0); }

  /* ---------------------------------------------------------------- path commands
   * cmds: [{t:'M',x,y},{t:'L',x,y},{t:'C',x1,y1,x2,y2,x,y},{t:'Q',x1,y1,x,y},{t:'Z'}] (absolute) */
  function arcTilC(x1, y1, rx, ry, phi, fa, fs, x2, y2, out) {
    if (rx === 0 || ry === 0) { out.push({ t: 'L', x: x2, y: y2 }); return; }
    var sinp = Math.sin(phi * Math.PI / 180), cosp = Math.cos(phi * Math.PI / 180);
    var dx = (x1 - x2) / 2, dy = (y1 - y2) / 2;
    var x1p = cosp * dx + sinp * dy, y1p = -sinp * dx + cosp * dy;
    rx = Math.abs(rx); ry = Math.abs(ry);
    var lam = x1p * x1p / (rx * rx) + y1p * y1p / (ry * ry);
    if (lam > 1) { rx *= Math.sqrt(lam); ry *= Math.sqrt(lam); }
    var num = rx * rx * ry * ry - rx * rx * y1p * y1p - ry * ry * x1p * x1p, den = rx * rx * y1p * y1p + ry * ry * x1p * x1p;
    var co = (fa === fs ? -1 : 1) * Math.sqrt(Math.max(0, num / (den || 1e-12)));
    var cxp = co * rx * y1p / ry, cyp = -co * ry * x1p / rx;
    var cx = cosp * cxp - sinp * cyp + (x1 + x2) / 2, cy = sinp * cxp + cosp * cyp + (y1 + y2) / 2;
    var ang = function (ux, uy, vx, vy) { var a = Math.atan2(ux * vy - uy * vx, ux * vx + uy * vy); return a; };
    var t1 = ang(1, 0, (x1p - cxp) / rx, (y1p - cyp) / ry);
    var dt = ang((x1p - cxp) / rx, (y1p - cyp) / ry, (-x1p - cxp) / rx, (-y1p - cyp) / ry);
    if (!fs && dt > 0) dt -= 2 * Math.PI; else if (fs && dt < 0) dt += 2 * Math.PI;
    var n = Math.max(1, Math.ceil(Math.abs(dt) / (Math.PI / 2) - 1e-9)), h = dt / n, k = 4 / 3 * Math.tan(h / 4);
    var pt = function (t) { var ct = Math.cos(t), st = Math.sin(t); return [cx + rx * ct * cosp - ry * st * sinp, cy + rx * ct * sinp + ry * st * cosp]; };
    var der = function (t) { var ct = Math.cos(t), st = Math.sin(t); return [-rx * st * cosp - ry * ct * sinp, -rx * st * sinp + ry * ct * cosp]; };
    for (var i = 0; i < n; i++) {
      var a0 = t1 + i * h, a1 = a0 + h, p0 = pt(a0), p1 = pt(a1), d0 = der(a0), d1 = der(a1);
      out.push({ t: 'C', x1: p0[0] + k * d0[0], y1: p0[1] + k * d0[1], x2: p1[0] - k * d1[0], y2: p1[1] - k * d1[1], x: i === n - 1 ? x2 : p1[0], y: i === n - 1 ? y2 : p1[1] });
    }
  }
  function lesaD(d) {
    var s = String(d || ''), i = 0, n = s.length, out = [];
    var cmd = '', cx = 0, cy = 0, sx = 0, sy = 0, lc = null, lq = null;
    function bil() { while (i < n && /[\s,]/.test(s.charAt(i))) i++; }
    function erTala() { bil(); return i < n && /[-+.\d]/.test(s.charAt(i)); }
    function tal() {
      bil();
      var m = /^[-+]?(?:\d+\.?\d*|\.\d+)(?:[eE][-+]?\d+)?/.exec(s.slice(i, i + 40));
      if (!m) throw villa('slod', 'tala vantar vid ' + i);
      i += m[0].length; return parseFloat(m[0]);
    }
    function flagg() { bil(); var c = s.charAt(i); if (c !== '0' && c !== '1') throw villa('slod', 'flagg vid ' + i); i++; return c === '1'; }
    while (true) {
      bil(); if (i >= n) break;
      var ch = s.charAt(i);
      if (/[a-zA-Z]/.test(ch)) { cmd = ch; i++; }
      else if (!cmd) throw villa('slod', 'skipun vantar');
      var C = cmd.toUpperCase(), rel = cmd !== C;
      if (C === 'Z') { out.push({ t: 'Z' }); cx = sx; cy = sy; lc = lq = null; cmd = ''; continue; }
      do {
        var x, y, x1, y1, x2, y2;
        if (C === 'M') { x = tal(); y = tal(); if (rel) { x += cx; y += cy; } out.push({ t: 'M', x: x, y: y }); cx = sx = x; cy = sy = y; C = 'L'; cmd = rel ? 'l' : 'L'; lc = lq = null; }
        else if (C === 'L') { x = tal(); y = tal(); if (rel) { x += cx; y += cy; } out.push({ t: 'L', x: x, y: y }); cx = x; cy = y; lc = lq = null; }
        else if (C === 'H') { x = tal(); if (rel) x += cx; out.push({ t: 'L', x: x, y: cy }); cx = x; lc = lq = null; }
        else if (C === 'V') { y = tal(); if (rel) y += cy; out.push({ t: 'L', x: cx, y: y }); cy = y; lc = lq = null; }
        else if (C === 'C' || C === 'S') {
          if (C === 'C') { x1 = tal(); y1 = tal(); if (rel) { x1 += cx; y1 += cy; } }
          else { x1 = lc ? 2 * cx - lc[0] : cx; y1 = lc ? 2 * cy - lc[1] : cy; }
          x2 = tal(); y2 = tal(); x = tal(); y = tal();
          if (rel) { x2 += cx; y2 += cy; x += cx; y += cy; }
          out.push({ t: 'C', x1: x1, y1: y1, x2: x2, y2: y2, x: x, y: y }); lc = [x2, y2]; lq = null; cx = x; cy = y;
        } else if (C === 'Q' || C === 'T') {
          if (C === 'Q') { x1 = tal(); y1 = tal(); if (rel) { x1 += cx; y1 += cy; } }
          else { x1 = lq ? 2 * cx - lq[0] : cx; y1 = lq ? 2 * cy - lq[1] : cy; }
          x = tal(); y = tal(); if (rel) { x += cx; y += cy; }
          out.push({ t: 'Q', x1: x1, y1: y1, x: x, y: y }); lq = [x1, y1]; lc = null; cx = x; cy = y;
        } else if (C === 'A') {
          var rx = tal(), ry = tal(), phi = tal(), fa = flagg(), fs = flagg();
          x = tal(); y = tal(); if (rel) { x += cx; y += cy; }
          arcTilC(cx, cy, rx, ry, phi, fa, fs, x, y, out); cx = x; cy = y; lc = lq = null;
        } else throw villa('slod', 'o\u00feekkt skipun ' + cmd);
      } while (erTala());
    }
    return out;
  }
  function umbreytaCmds(cmds, m) {
    if (erEining(m)) return cmds;
    var T = function (x, y) { return [m[0] * x + m[2] * y + m[4], m[1] * x + m[3] * y + m[5]]; };
    return cmds.map(function (c) {
      if (c.t === 'Z') return c;
      var o = { t: c.t }, p = T(c.x, c.y); o.x = p[0]; o.y = p[1];
      if (c.t === 'C') { p = T(c.x1, c.y1); o.x1 = p[0]; o.y1 = p[1]; p = T(c.x2, c.y2); o.x2 = p[0]; o.y2 = p[1]; }
      if (c.t === 'Q') { p = T(c.x1, c.y1); o.x1 = p[0]; o.y1 = p[1]; }
      return o;
    });
  }
  /* absolute, 3 decimals: the d-string helpers for adapters (dRett, dHringur, dSporaskja), i.e. input */
  function cmdsTilDAbs(cmds) {
    var s = '';
    for (var i = 0; i < cmds.length; i++) {
      var c = cmds[i];
      if (c.t === 'Z') s += 'Z';
      else if (c.t === 'C') s += 'C' + f3(c.x1) + ' ' + f3(c.y1) + ' ' + f3(c.x2) + ' ' + f3(c.y2) + ' ' + f3(c.x) + ' ' + f3(c.y);
      else if (c.t === 'Q') s += 'Q' + f3(c.x1) + ' ' + f3(c.y1) + ' ' + f3(c.x) + ' ' + f3(c.y);
      else s += c.t + f3(c.x) + ' ' + f3(c.y);
    }
    return s;
  }
  /* ---------------------------------------------------------------- compact path output (the file)
   * Every point is rounded to the 0.01 mm grid first and then written relative to the previous rounded
   * point (lower-case commands, repeated commands without the letter, h/v for straight lines), so the
   * rounding never adds up: each written point is within 0.0071 mm of the computed one. Numbers keep
   * the leading zero and use the minus sign as a separator, the path syntax Adobe Illustrator writes. */
  function hnit(v) { return Math.round(v * 100); }
  function talaH(h) {
    var neg = h < 0; if (neg) h = -h;
    var e = Math.floor(h / 100), b = h - e * 100, s = String(e);
    if (b) s += '.' + (b < 10 ? '0' + b : String(b % 10 ? b : b / 10));
    return neg ? '-' + s : s;
  }
  function Skrifari() { this.s = ''; this.k = ''; this.x = 0; this.y = 0; this.sx = 0; this.sy = 0; this.ny = false; this.opin = false; }
  Skrifari.prototype.sk = function (k, alltaf) { if (alltaf || this.k !== k) { this.s += k; this.k = k; this.ny = true; } };
  Skrifari.prototype.t = function (h) { var t = talaH(h); this.s += (this.ny || t.charAt(0) === '-') ? t : ' ' + t; this.ny = false; };
  Skrifari.prototype.faera = function (x, y) {
    if (!this.s) { this.sk('M', true); this.t(x); this.t(y); } else { this.sk('m', true); this.t(x - this.x); this.t(y - this.y); }
    this.x = this.sx = x; this.y = this.sy = y; this.opin = true;
  };
  Skrifari.prototype.lina = function (x, y) {
    var dx = x - this.x, dy = y - this.y;
    if (!dx && !dy) return;
    if (!dy) { this.sk('h', true); this.t(dx); } else if (!dx) { this.sk('v', true); this.t(dy); } else { this.sk('l'); this.t(dx); this.t(dy); }
    this.x = x; this.y = y; this.opin = true;
  };
  Skrifari.prototype.ferill = function (a) {
    var i, allt0 = true;
    for (i = 0; i < a.length; i++) if (a[i] !== (i % 2 ? this.y : this.x)) allt0 = false;
    if (allt0) return;
    this.sk('c');
    for (i = 0; i < a.length; i++) this.t(a[i] - (i % 2 ? this.y : this.x));
    this.x = a[a.length - 2]; this.y = a[a.length - 1]; this.opin = true;
  };
  Skrifari.prototype.loka = function () { if (!this.opin) return; this.sk('z', true); this.x = this.sx; this.y = this.sy; this.opin = false; };
  /* one or more command lists (e.g. all glyphs of a text) -> one compact d string. Only m, l, h, v, c, z
   * are written (a quadratic curve becomes the identical cubic), as in the approved samples. */
  function cmdsTilD(listi) {
    var w = new Skrifari(), k, i, c, px = 0, py = 0, sx = 0, sy = 0;
    for (k = 0; k < listi.length; k++) {
      for (i = 0; i < listi[k].length; i++) {
        c = listi[k][i];
        if (c.t === 'Z') { w.loka(); px = sx; py = sy; continue; }
        if (c.t === 'M') { w.faera(hnit(c.x), hnit(c.y)); sx = c.x; sy = c.y; }
        else if (c.t === 'L') w.lina(hnit(c.x), hnit(c.y));
        else if (c.t === 'C') w.ferill([hnit(c.x1), hnit(c.y1), hnit(c.x2), hnit(c.y2), hnit(c.x), hnit(c.y)]);
        else if (c.t === 'Q') w.ferill([hnit(px + 2 / 3 * (c.x1 - px)), hnit(py + 2 / 3 * (c.y1 - py)), hnit(c.x + 2 / 3 * (c.x1 - c.x)), hnit(c.y + 2 / 3 * (c.y1 - c.y)), hnit(c.x), hnit(c.y)]);
        px = c.x; py = c.y;
      }
    }
    return w.s;
  }
  var KAPPA = 0.5522847498307936;
  function cmdsSporaskja(cx, cy, rx, ry) {
    var kx = rx * KAPPA, ky = ry * KAPPA;
    return [{ t: 'M', x: cx + rx, y: cy },
      { t: 'C', x1: cx + rx, y1: cy + ky, x2: cx + kx, y2: cy + ry, x: cx, y: cy + ry },
      { t: 'C', x1: cx - kx, y1: cy + ry, x2: cx - rx, y2: cy + ky, x: cx - rx, y: cy },
      { t: 'C', x1: cx - rx, y1: cy - ky, x2: cx - kx, y2: cy - ry, x: cx, y: cy - ry },
      { t: 'C', x1: cx + kx, y1: cy - ry, x2: cx + rx, y2: cy - ky, x: cx + rx, y: cy }, { t: 'Z' }];
  }
  function cmdsRett(x, y, w, h, rx, ry) {
    rx = Math.max(0, Math.min(rx || 0, w / 2)); ry = Math.max(0, Math.min(ry == null ? rx : ry, h / 2));
    if (!rx || !ry) return [{ t: 'M', x: x, y: y }, { t: 'L', x: x + w, y: y }, { t: 'L', x: x + w, y: y + h }, { t: 'L', x: x, y: y + h }, { t: 'Z' }];
    var kx = rx * KAPPA, ky = ry * KAPPA;
    return [{ t: 'M', x: x + rx, y: y }, { t: 'L', x: x + w - rx, y: y },
      { t: 'C', x1: x + w - rx + kx, y1: y, x2: x + w, y2: y + ry - ky, x: x + w, y: y + ry },
      { t: 'L', x: x + w, y: y + h - ry },
      { t: 'C', x1: x + w, y1: y + h - ry + ky, x2: x + w - rx + kx, y2: y + h, x: x + w - rx, y: y + h },
      { t: 'L', x: x + rx, y: y + h },
      { t: 'C', x1: x + rx - kx, y1: y + h, x2: x, y2: y + h - ry + ky, x: x, y: y + h - ry },
      { t: 'L', x: x, y: y + ry },
      { t: 'C', x1: x, y1: y + ry - ky, x2: x + rx - kx, y2: y, x: x + rx, y: y }, { t: 'Z' }];
  }

  /* ---------------------------------------------------------------- flattening and clipper */
  function flatC(p0, p1, p2, p3, out, depth) {
    var dx = p3[0] - p0[0], dy = p3[1] - p0[1], L = Math.sqrt(dx * dx + dy * dy) || 1e-12;
    var d1 = Math.abs((p1[0] - p3[0]) * dy - (p1[1] - p3[1]) * dx) / L;
    var d2 = Math.abs((p2[0] - p3[0]) * dy - (p2[1] - p3[1]) * dx) / L;
    if (depth > 18 || (d1 + d2) <= TOL) { out.push(p3); return; }
    var m = function (a, b) { return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]; };
    var p01 = m(p0, p1), p12 = m(p1, p2), p23 = m(p2, p3), p012 = m(p01, p12), p123 = m(p12, p23), mid = m(p012, p123);
    flatC(p0, p01, p012, mid, out, depth + 1); flatC(mid, p123, p23, p3, out, depth + 1);
  }
  function flatten(cmds) {
    var polys = [], cur = null, pt = null;
    for (var i = 0; i < cmds.length; i++) {
      var c = cmds[i];
      if (c.t === 'M') { if (cur && cur.length > 2) polys.push(cur); cur = [[c.x, c.y]]; pt = [c.x, c.y]; }
      else if (!cur) continue;
      else if (c.t === 'L') { cur.push([c.x, c.y]); pt = [c.x, c.y]; }
      else if (c.t === 'C') { flatC(pt, [c.x1, c.y1], [c.x2, c.y2], [c.x, c.y], cur, 0); pt = [c.x, c.y]; }
      else if (c.t === 'Q') { flatC(pt, [pt[0] + 2 / 3 * (c.x1 - pt[0]), pt[1] + 2 / 3 * (c.y1 - pt[1])], [c.x + 2 / 3 * (c.x1 - c.x), c.y + 2 / 3 * (c.y1 - c.y)], [c.x, c.y], cur, 0); pt = [c.x, c.y]; }
      else if (c.t === 'Z') { if (cur.length > 2) polys.push(cur); pt = cur[0]; cur = null; }
    }
    if (cur && cur.length > 2) polys.push(cur);
    return polys;
  }
  function signedArea(polys) {
    var s = 0;
    for (var k = 0; k < polys.length; k++) {
      var p = polys[k], a = 0;
      for (var i = 0; i < p.length; i++) { var q = p[(i + 1) % p.length]; a += p[i][0] * q[1] - q[0] * p[i][1]; }
      s += a / 2;
    }
    return s;
  }
  function tilC(polys) { return polys.map(function (p) { return p.map(function (q) { return { X: Math.round(q[0] * SC), Y: Math.round(q[1] * SC) }; }); }); }
  function flatarmal(paths) { var CL = W.ClipperLib, s = 0; for (var i = 0; i < paths.length; i++) s += CL.Clipper.Area(paths[i]); return s / SC / SC; }
  function klippa(tegund, a, b) {
    var CL = W.ClipperLib, c = new CL.Clipper(), NZ = CL.PolyFillType.pftNonZero, out = new CL.Paths();
    c.AddPaths(tilC(a), CL.PolyType.ptSubject, true);
    if (b && b.length) c.AddPaths(tilC(b), CL.PolyType.ptClip, true);
    c.Execute(tegund === 'mismunur' ? CL.ClipType.ctDifference : CL.ClipType.ctUnion, out, NZ, NZ);
    return out;
  }
  /* one closed ring on the 0.01 mm grid: drops repeated points and points on the straight line between
   * their neighbours (exact integer test, so the shape does not change at all) */
  function beinn(q) {
    var r = [], i, n;
    for (i = 0; i < q.length; i++) { var b = r[r.length - 1]; if (!b || q[i][0] !== b[0] || q[i][1] !== b[1]) r.push(q[i]); }
    while (r.length > 1 && r[0][0] === r[r.length - 1][0] && r[0][1] === r[r.length - 1][1]) r.pop();
    n = r.length; if (n < 3) return r;
    var ut = [];
    for (i = 0; i < n; i++) {
      var A = r[(i + n - 1) % n], B = r[i], C = r[(i + 1) % n];
      var ux = B[0] - A[0], uy = B[1] - A[1], vx = C[0] - B[0], vy = C[1] - B[1];
      if (ux * vy - uy * vx === 0 && ux * vx + uy * vy > 0) continue;
      ut.push(B);
    }
    return ut;
  }
  /* Douglas-Peucker on one closed ring (integer 0.01 mm points): keeps the points needed to stay within
   * eps of the flattened outline */
  function einfalda(q, eps) {
    var n = q.length, keep = [], i, f = 0, fd = -1, dx, dy, d;
    if (n < 4) return q;
    for (i = 1; i < n; i++) { dx = q[i][0] - q[0][0]; dy = q[i][1] - q[0][1]; d = dx * dx + dy * dy; if (d > fd) { fd = d; f = i; } }
    keep[0] = keep[f] = true;
    var bid = [[0, f], [f, n]];
    while (bid.length) {
      var b = bid.pop(), a0 = b[0], a1 = b[1], A = q[a0], B = q[a1 % n], mx = -1, mi = -1;
      var vx = B[0] - A[0], vy = B[1] - A[1], L = Math.sqrt(vx * vx + vy * vy);
      for (i = a0 + 1; i < a1; i++) {
        dx = q[i][0] - A[0]; dy = q[i][1] - A[1];
        d = L ? Math.abs(dx * vy - dy * vx) / L : Math.sqrt(dx * dx + dy * dy);
        if (d > mx) { mx = d; mi = i; }
      }
      if (mi >= 0 && mx > eps) { keep[mi] = true; bid.push([a0, mi], [mi, a1]); }
    }
    var r = []; for (i = 0; i < n; i++) if (keep[i]) r.push(q[i]);
    return r;
  }
  function polysTilD(paths) {
    var w = new Skrifari(), K = SC / 100;
    for (var i = 0; i < paths.length; i++) {
      var p = paths[i], q = [], j;
      if (p.length < 3) continue;
      for (j = 0; j < p.length; j++) q.push([Math.round(p[j].X / K), Math.round(p[j].Y / K)]);
      q = beinn(einfalda(beinn(q), EINF)); if (q.length < 3) continue;
      w.faera(q[0][0], q[0][1]);
      for (j = 1; j < q.length; j++) w.lina(q[j][0], q[j][1]);
      w.loka();
    }
    return w.s;
  }

  /* ---------------------------------------------------------------- fonts and shaping */
  function leturUppl(id) { return LETUR[id] || null; }
  var leturGogn = {}, leturLofor = {}, libLofor = {};
  function stillingar() { return W.SMFramSlodir || {}; }
  var SJALF = (D && D.currentScript && D.currentScript.src) || '';
  function grunnur() {
    var c = stillingar();
    if (c.grunnur) return c.grunnur;
    var src = SJALF;
    if (!src && D && D.querySelector) { var s = D.querySelector('script[src*="sm-framleidsla"]'); if (s) src = s.src; }
    return src ? src.replace(/[?#].*$/, '').replace(/[^\/]*$/, '') : '';
  }
  function leturSlod(id) {
    var c = stillingar();
    if (c.letur && c.letur[id]) return c.letur[id];
    var L = LETUR[id]; return L ? grunnur() + L.skra : '';
  }
  function hefurLetur(id) {
    if (leturGogn[id]) return true;
    var c = stillingar(), L = LETUR[id];
    if (c.letur && c.letur[id]) return true;
    return !!(L && L.virkt !== false);
  }
  function skraLetur(id, st) {
    st = st || {};
    if (!LETUR[id]) LETUR[id] = { f: st.nafn || id, a: st.alias || '', w: st.thykkt || 400, i: st.skaletrad ? 1 : 0, u: st.uppruni || id, skra: 'sm-letur-' + id + '.json' };
    else { if (st.uppruni) LETUR[id].u = st.uppruni; if (st.alias) LETUR[id].a = st.alias; }
    if (st.gogn) leturGogn[id] = st.gogn;
    if (st.url) { var c = W.SMFramSlodir = W.SMFramSlodir || {}; c.letur = c.letur || {}; c.letur[id] = st.url; }
    if (st.gogn || st.url) { LETUR[id].virkt = true; LETUR[id].gf = st.gf ? 1 : 0; }
    delete leturLofor[id];
    return id;
  }
  function hladaLib(lykill, skra, glob) {
    if (W[glob]) return Promise.resolve(W[glob]);
    if (libLofor[lykill]) return libLofor[lykill];
    var p = new Promise(function (res, rej) {
      if (!D || !D.createElement) { rej(villa('lib', skra)); return; }
      var c = stillingar(), s = D.createElement('script');
      s.src = c[lykill] || (grunnur() + skra); s.async = true;
      s.onload = function () { if (W[glob]) res(W[glob]); else rej(villa('lib', skra)); };
      s.onerror = function () { rej(villa('lib', skra)); };
      (D.head || D.documentElement).appendChild(s);
    });
    libLofor[lykill] = p;
    p['catch'](function () { delete libLofor[lykill]; });
    return p;
  }
  function hladaOpentype() { return hladaLib('opentype', 'sm-opentype.min.js', 'opentype'); }
  function hladaClipper() { return hladaLib('clipper', 'sm-clipper.min.js', 'ClipperLib'); }

  /* lookups of one feature for Latin text: script latn, else DFLT; default language system */
  function lookups(tafla, tag, tegund) {
    if (!tafla || !tafla.scripts || !tafla.features || !tafla.lookups) return [];
    var scr = null, i, k;
    for (k = 0; k < 3 && !scr; k++) for (i = 0; i < tafla.scripts.length; i++) if (tafla.scripts[i].tag === ['latn', 'DFLT', 'dflt'][k]) { scr = tafla.scripts[i].script; break; }
    if (!scr || !scr.defaultLangSys) return [];
    var ls = scr.defaultLangSys, idx = (ls.featureIndexes || []).slice(), vals = {};
    if (ls.reqFeatureIndex != null && ls.reqFeatureIndex !== 0xFFFF) idx.push(ls.reqFeatureIndex);
    for (i = 0; i < idx.length; i++) {
      var fe = tafla.features[idx[i]];
      if (fe && fe.tag === tag) for (k = 0; k < fe.feature.lookupListIndexes.length; k++) vals[fe.feature.lookupListIndexes[k]] = 1;
    }
    var out = [];
    Object.keys(vals).map(Number).sort(function (a, b) { return a - b; }).forEach(function (n) { var L = tafla.lookups[n]; if (L && L.lookupType === tegund) out.push(L); });
    return out;
  }
  function undirbuaLetur(id, font) {
    return {
      id: id, font: font, upem: font.unitsPerEm,
      liga: lookups(font.tables.gsub, 'liga', 4).concat(lookups(font.tables.gsub, 'clig', 4)),
      rlig: lookups(font.tables.gsub, 'rlig', 4),
      kern: lookups(font.tables.gpos, 'kern', 2),
      cov: font.substitution || font.position
    };
  }
  /* Font asset -> font bytes (ArrayBuffer). sm-letur-<id>.json = {"id", "bytes", "b64": WOFF}; a .js asset
   * holds the same fields in an object literal (it can start with a licence comment; the CDN minifies .js
   * but keeps string literals). A raw WOFF/OTF/TTF answer is used as it is (local tests); WOFF2 is refused,
   * opentype.js 1.3.4 cannot read it. */
  function b64Buf(b64) {
    var bin = W.atob(String(b64).replace(/[^A-Za-z0-9+\/=]/g, '')), n = bin.length, u = new Uint8Array(n);
    for (var i = 0; i < n; i++) u[i] = bin.charCodeAt(i);
    return u.buffer;
  }
  function leturBaeti(id, buf) {
    var u = new Uint8Array(buf), sig = u.length >= 4 ? String.fromCharCode(u[0], u[1], u[2], u[3]) : '';
    if (sig === 'wOFF' || sig === 'OTTO' || sig === 'true' || sig === '\u0000\u0001\u0000\u0000') return buf;
    if (sig === 'wOF2') throw villa('letur-hladst-ekki', id + ' WOFF2');
    var s = '', i, o = null, m;
    for (i = 0; i < u.length; i += 8192) s += String.fromCharCode.apply(null, u.subarray(i, i + 8192));
    if (/^\s*\{/.test(s)) { try { o = JSON.parse(s); } catch (e) { o = null; } }
    else if ((m = /\bb64\s*:\s*(["'])([A-Za-z0-9+\/=\\\s]+)\1/.exec(s))) {
      o = { b64: m[2] };
      if ((m = /\bbytes\s*:\s*(\d+)/.exec(s))) o.bytes = +m[1];
      if ((m = /\bid\s*:\s*(["'])([^"']+)\1/.exec(s))) o.id = m[2];
    }
    if (!o || !o.b64) throw villa('letur-hladst-ekki', id + ' snid');
    if (o.id && o.id !== id) throw villa('letur-hladst-ekki', id + ' er ' + o.id);
    var b = b64Buf(o.b64);
    if (o.bytes && b.byteLength !== o.bytes) throw villa('letur-hladst-ekki', id + ' lengd ' + b.byteLength);
    return b;
  }
  function hladaLetur(id) {
    if (leturLofor[id]) return leturLofor[id];
    var p = hladaOpentype().then(function (ot) {
      if (leturGogn[id]) return ot.parse(leturGogn[id]);
      var fyrir = W.SMFramLetur && W.SMFramLetur[id];
      if (fyrir && fyrir.b64) return ot.parse(b64Buf(fyrir.b64));
      if (!hefurLetur(id)) throw villa('letur-vantar', id);
      var url = leturSlod(id);
      if (!url) throw villa('letur-vantar', id);
      return fetch(url).then(function (r) {
        if (!r.ok) throw villa('letur-hladst-ekki', id + ' ' + r.status);
        return r.arrayBuffer();
      }).then(function (b) { return ot.parse(leturBaeti(id, b)); });
    }).then(function (font) {
      if (!font || !font.glyphs || !font.unitsPerEm) throw villa('letur-hladst-ekki', id);
      return undirbuaLetur(id, font);
    });
    leturLofor[id] = p;
    p['catch'](function () { delete leturLofor[id]; });
    return p;
  }
  function coverage(L, cov, g) { return L.cov.getCoverageIndex(cov, g); }
  function beitaLig(L, luk, gl) {
    for (var u = 0; u < luk.length; u++) {
      var lk = luk[u], out = [], i = 0;
      while (i < gl.length) {
        var buid = false;
        for (var s = 0; s < lk.subtables.length && !buid; s++) {
          var st = lk.subtables[s];
          if (!st || !st.coverage || !st.ligatureSets) continue;
          var ci = coverage(L, st.coverage, gl[i].g); if (ci < 0) continue;
          var set = st.ligatureSets[ci] || [];
          for (var k = 0; k < set.length && !buid; k++) {
            var comps = set[k].components, ok = i + comps.length < gl.length;
            for (var m = 0; ok && m < comps.length; m++) if (gl[i + 1 + m].g !== comps[m] || gl[i + 1 + m].bil || gl[i + 1 + m].s !== gl[i].s) ok = false;
            if (ok && !gl[i].bil) {
              var n = gl[i].n; for (m = 0; m < comps.length; m++) n += gl[i + 1 + m].n;
              out.push({ g: set[k].ligGlyph, c: gl[i].c, n: n, s: gl[i].s }); i += comps.length + 1; buid = true;
            }
          }
        }
        if (!buid) { out.push(gl[i]); i++; }
      }
      gl = out;
    }
    return gl;
  }
  function gildi(v, k) { return v && v[k] ? v[k] : 0; }
  function kerna(L, a, b) {
    var r = { a1: 0, p1: 0, a2: 0, p2: 0, v2: false }, fannst = false;
    for (var u = 0; u < L.kern.length; u++) {
      var lk = L.kern[u];
      for (var s = 0; s < lk.subtables.length; s++) {
        var st = lk.subtables[s], v1 = null, v2 = null, ok = false;
        if (!st || !st.coverage) continue;
        var ci = coverage(L, st.coverage, a); if (ci < 0) continue;
        if (st.posFormat === 1) {
          var ps = st.pairSets[ci] || [];
          for (var k = 0; k < ps.length; k++) if (ps[k].secondGlyph === b) { v1 = ps[k].value1; v2 = ps[k].value2; ok = true; break; }
        } else if (st.posFormat === 2) {
          var c1 = L.cov.getGlyphClass(st.classDef1, a), c2 = L.cov.getGlyphClass(st.classDef2, b);
          var rec = st.classRecords[c1] && st.classRecords[c1][c2];
          if (rec) { v1 = rec.value1; v2 = rec.value2; ok = true; }
        }
        if (ok) {
          r.a1 += gildi(v1, 'xAdvance'); r.p1 += gildi(v1, 'xPlacement'); r.a2 += gildi(v2, 'xAdvance'); r.p2 += gildi(v2, 'xPlacement');
          if (st.valueFormat2) r.v2 = true;
          fannst = true; break;
        }
      }
    }
    if (!fannst && !L.kern.length && L.font.kerningPairs) r.a1 = L.font.kerningPairs[a + ',' + b] || 0;
    return r;
  }

  /* ---------------------------------------------------------------- U+1F43E (CW 19.10, eigandi)
   * The paw U+1F43E is the ONE symbol customers may type ("Zorro & Branda U+1F43E"). It is engraved as a vector, the
   * same shape as the cross symbol "Loppa" (sm-kr-takn-loppa.json, simplified 0.06 % of its box), never an emoji
   * glyph: height 0.8 x the cap height of the line's font, sitting on the baseline, a side bearing of 0.12 x its
   * height on each side, same layer as the text. One integer outline in 2048 units per em (loppaGlyf) feeds
   * both the production file (uppsetning/textiCmds) and the preview: a tiny TrueType font (loppaTtf) added to
   * every web font family on the page for U+1F43E and U+FE0F only (FontFace, same descriptors as the family's
   * own faces), so the browser lays out, measures (canvas, DOM) and draws the paw exactly like the file. */
  var LOPPA = 0x1F43E, LOPPA_UPM = 2048, LOPPA_HL = 1.053721, LOPPA_HAED = 0.8, LOPPA_BIL = 0.12;
  var LOPPA_P = '3272,3,3123,22,2996,58,2874,115,2751,196,2661,275,2545,404,2458,527,2364,692,2290,852,2237,1001,2193,1155,2149,1381,2125,1603,2115,1834,2130,2184,2184,2539,2237,2745,2330,3007,2418,3208,2506,3373,2609,3532,2706,3656,2898,3843,3025,3935,3176,4021,3303,4074,3425,4110,3567,4131,3708,4131,3865,4104,4006,4058,4221,3940,4333,3852,4427,3759,4506,3661,4583,3537,4641,3419,4696,3275,4750,3074,4784,2879,4814,2524,4799,2128,4770,1901,4731,1695,4643,1361,4589,1196,4526,1037,4427,831,4345,687,4247,543,4149,419,4031,295,3933,212,3801,125,3708,79,3552,27,3357,1;6613,3,6482,21,6355,58,6243,105,6121,176,6018,253,5898,368,5719,599,5611,779,5505,990,5377,1315,5314,1526,5265,1736,5211,2117,5200,2287,5201,2575,5230,2946,5288,3213,5333,3342,5397,3486,5484,3635,5553,3728,5637,3822,5769,3935,5862,3997,5989,4059,6116,4100,6257,4125,6375,4130,6560,4110,6702,4069,6833,4013,6970,3935,7122,3822,7271,3676,7353,3578,7450,3440,7544,3280,7612,3141,7704,2915,7772,2704,7821,2508,7861,2282,7880,2102,7890,1860,7885,1664,7865,1448,7831,1237,7753,954,7669,754,7577,584,7480,440,7389,332,7268,217,7151,135,7043,78,6897,27,6741,1;1003,2940,901,2954,735,3005,613,3063,510,3129,398,3228,308,3331,240,3434,177,3558,118,3717,74,3887,26,4155,6,4350,6,4721,26,4906,60,5096,103,5266,163,5446,230,5611,318,5791,436,5991,538,6136,652,6267,759,6369,876,6456,999,6528,1101,6574,1233,6616,1331,6637,1472,6652,1677,6647,1799,6626,1951,6580,2058,6528,2166,6460,2253,6389,2347,6295,2436,6182,2505,6074,2567,5950,2645,5719,2670,5600,2690,5431,2680,5019,2656,4813,2626,4654,2582,4484,2518,4299,2441,4108,2353,3928,2196,3671,2094,3537,1976,3403,1750,3201,1594,3093,1477,3031,1335,2976,1228,2950,1121,2938;8852,2946,8704,2970,8596,3001,8484,3047,8367,3110,8250,3191,8147,3279,7906,3542,7774,3722,7686,3861,7535,4160,7423,4474,7344,4829,7311,5163,7316,5467,7364,5745,7412,5894,7462,6007,7531,6130,7619,6254,7698,6342,7810,6441,7961,6538,8040,6574,8176,6621,8274,6642,8367,6653,8567,6647,8806,6595,8943,6543,9080,6472,9207,6384,9316,6290,9433,6166,9540,6028,9652,5847,9740,5678,9819,5492,9878,5317,9960,4957,9985,4767,9999,4520,9980,4139,9951,3954,9916,3810,9852,3630,9790,3501,9696,3352,9602,3235,9509,3145,9387,3057,9260,2995,9138,2959,9021,2943;5002,4613,4851,4621,4724,4642,4578,4682,4421,4746,4290,4816,4138,4919,4036,5002,3894,5137,3771,5271,3595,5487,2914,6408,2300,7154,2086,7463,1925,7746,1857,7895,1797,8060,1754,8219,1725,8384,1709,8621,1719,8806,1768,9048,1817,9187,1886,9326,2023,9521,2131,9635,2273,9754,2405,9840,2498,9888,2683,9956,2869,9991,3210,9991,3352,9970,3557,9924,3777,9857,4319,9669,4563,9602,4817,9560,5090,9550,5310,9576,5530,9628,5706,9680,6257,9872,6536,9949,6814,9991,7102,9990,7253,9965,7429,9914,7556,9858,7722,9759,7854,9651,8007,9485,8109,9331,8173,9207,8241,9022,8285,8816,8300,8605,8281,8363,8232,8147,8133,7869,8007,7612,7856,7370,7714,7180,6935,6202,6405,5482,6235,5276,6038,5069,5911,4956,5764,4848,5535,4724,5393,4672,5256,4637,5110,4617';
  /* cap height / em of the web font families (OS/2 sCapHeight of the same font files SMFram reads,
   * yfirferd/loppa-2026-10-19/prof/hastafir.mjs); family|weight where the weights differ */
  var LOPPA_HASTAFIR = { 'montserrat': 0.7, 'jost': 0.7, 'cormorant garamond': 0.625, 'sm skrift': 0.72, 'dancing script': 0.72,
    'tinos': 0.6548, 'fraunces': 0.7, 'eb garamond': 0.65, 'outfit': 0.7, 'outfit|400': 0.694, 'outfit|800': 0.709,
    'nunito': 0.705, 'nunito sans': 0.705, 'archivo': 0.686, 'arimo': 0.688, 'cinzel': 0.7, 'bebas neue': 0.7,
    'rounded elegance open': 0.6504, 'inter': 0.7275, 'sm inter': 0.7275, 'sm inter bryr': 0.7275, 'rubik': 0.7,
    'sm rubik': 0.7, 'sm rubik bryr': 0.7, 'sm didot': 0.689, 'sm didot bryr': 0.689, 'sacramento': 0.7568,
    'tex gyre heros': 0.729, 'sm mono': 0.698, 'barlow semi condensed': 0.7, 'smf rundad': 0.7, 'quicksand': 0.7 };
  function loppaHlutfall(fam, w) {
    var f = String(fam || '').split(',')[0].replace(/["']/g, '').trim().toLowerCase();
    return LOPPA_HASTAFIR[f + '|' + parseInt(w, 10)] || LOPPA_HASTAFIR[f] || 0.7;
  }
  var loppaSkyndi = {};
  /* the paw in font units (2048/em, y up) for a font whose cap height is r em: { adv, h, polys: [[x, y, ...]] } */
  function loppaGlyf(r) {
    r = Math.round(r * 1e4) / 1e4;
    if (loppaSkyndi[r]) return loppaSkyndi[r];
    var H = LOPPA_HAED * r * LOPPA_UPM, Wd = H * LOPPA_HL, sb = Math.round(LOPPA_BIL * H), polys = [];
    LOPPA_P.split(';').forEach(function (s) {
      var a = s.split(',').map(Number), p = [], i, x, y, px = null, py = null, fl = 0;
      for (i = 0; i < a.length; i += 2) {
        x = sb + Math.round(a[i] / 1e4 * Wd); y = Math.round(H * (1 - a[i + 1] / 1e4));
        if (x === px && y === py) continue;
        p.push(x, y); px = x; py = y;
      }
      if (p.length > 2 && p[0] === p[p.length - 2] && p[1] === p[p.length - 1]) p.length -= 2;
      for (i = 0; i < p.length; i += 2) { var j = (i + 2) % p.length; fl += p[i] * p[j + 1] - p[j] * p[i + 1]; }
      if (fl > 0) { var q = []; for (i = p.length - 2; i >= 0; i -= 2) q.push(p[i], p[i + 1]); p = q; } /* clockwise (TrueType outer) */
      if (p.length >= 6) polys.push(p);
    });
    return (loppaSkyndi[r] = { adv: Math.round(Wd + 2 * sb), h: Math.round(H), polys: polys });
  }
  function erLoppa(c) { return c === '\ud83d\udc3e'; }
  /* cap height / em of a font SMFram has read: the same table as the web fonts, else the font's own OS/2 */
  function loppaR(L) {
    var o = LETUR[L.id] || {}, r = LOPPA_HASTAFIR[String(o.a || o.f || '').toLowerCase() + '|' + o.w] || LOPPA_HASTAFIR[String(o.a || '').toLowerCase()] || LOPPA_HASTAFIR[String(o.f || '').toLowerCase()];
    if (r) return r;
    var os2 = L.font.tables && L.font.tables.os2, ch = os2 && os2.sCapHeight;
    if (!(ch > 0)) { var hg = L.font.charToGlyph('H'); ch = hg && hg.getBoundingBox ? hg.getBoundingBox().y2 : 0.7 * L.upem; }
    return Math.round(ch / L.upem * 1e4) / 1e4;
  }
  /* opentype-like path commands of the paw at x (mm), baseline 0, y down, size mm */
  function loppaCmds(G, x, mm) {
    var k = mm / LOPPA_UPM, out = [];
    G.polys.forEach(function (p) {
      var c = [];
      for (var i = 0; i < p.length; i += 2) c.push({ t: i ? 'L' : 'M', x: x + p[i] * k, y: -p[i + 1] * k });
      c.push({ t: 'Z' }); out.push(c);
    });
    return out;
  }
  /* TrueType font with the paw at U+1F43E and an empty U+FE0F (r = cap height / em of the family it joins) */
  function loppaTtf(r) {
    var G = loppaGlyf(r), U = LOPPA_UPM;
    function B() { this.a = []; }
    B.prototype = { u8: function (v) { this.a.push(v & 255); return this; }, u16: function (v) { this.a.push((v >> 8) & 255, v & 255); return this; },
      i16: function (v) { return this.u16(v < 0 ? v + 65536 : v); }, u32: function (v) { this.a.push((v >>> 24) & 255, (v >>> 16) & 255, (v >>> 8) & 255, v & 255); return this; },
      tag: function (s) { for (var i = 0; i < 4; i++) this.u8(s.charCodeAt(i)); return this; }, pad: function () { while (this.a.length % 4) this.a.push(0); return this; } };
    var xs = [], ys = [], npt = 0;
    G.polys.forEach(function (p) { for (var i = 0; i < p.length; i += 2) { xs.push(p[i]); ys.push(p[i + 1]); } npt += p.length / 2; });
    var xMin = Math.min.apply(null, xs), xMax = Math.max.apply(null, xs), yMin = Math.min.apply(null, ys), yMax = Math.max.apply(null, ys);
    var asc = Math.round(0.9 * U), dsc = Math.round(0.2 * U);
    /* glyf: 0 .notdef (empty), 1 the paw, 2 U+FE0F (empty) */
    var g = new B(), end = -1;
    g.i16(G.polys.length).i16(xMin).i16(yMin).i16(xMax).i16(yMax);
    G.polys.forEach(function (p) { end += p.length / 2; g.u16(end); });
    g.u16(0);
    for (var i = 0; i < npt; i++) g.u8(1);
    var px = 0, py = 0;
    G.polys.forEach(function (p) { for (var i = 0; i < p.length; i += 2) { g.i16(p[i] - px); px = p[i]; } });
    G.polys.forEach(function (p) { for (var i = 1; i < p.length; i += 2) { g.i16(p[i] - py); py = p[i]; } });
    g.pad();
    var glen = g.a.length;
    var loca = new B().u32(0).u32(0).u32(glen).u32(glen);
    var hmtx = new B().u16(Math.round(U / 4)).i16(0).u16(G.adv).i16(xMin).u16(0).i16(0);
    var cmap = new B();
    cmap.u16(0).u16(2).u16(3).u16(1).u32(20).u16(3).u16(10).u32(20 + 32);
    cmap.u16(4).u16(32).u16(0).u16(4).u16(4).u16(1).u16(0).u16(0xFE0F).u16(0xFFFF).u16(0).u16(0xFE0F).u16(0xFFFF).u16((2 - 0xFE0F + 65536) & 0xFFFF).u16(1).u16(0).u16(0);
    cmap.u16(12).u16(0).u32(40).u32(0).u32(2).u32(0xFE0F).u32(0xFE0F).u32(2).u32(LOPPA).u32(LOPPA).u32(1);
    var head = new B().u32(0x10000).u32(0x10000).u32(0).u32(0x5F0F3CF5).u16(0x000B).u16(U).u32(0).u32(0).u32(0).u32(0)
      .i16(xMin).i16(yMin).i16(xMax).i16(yMax).u16(0).u16(8).i16(2).i16(1).i16(0);
    var hhea = new B().u32(0x10000).i16(asc).i16(-dsc).i16(0).u16(G.adv).i16(0).i16(0).i16(xMax).i16(1).i16(0).i16(0).i16(0).i16(0).i16(0).i16(0).i16(0).u16(3);
    var maxp = new B().u32(0x10000).u16(3).u16(npt).u16(G.polys.length).u16(0).u16(0).u16(2).u16(0).u16(0).u16(0).u16(0).u16(0).u16(0).u16(0).u16(0);
    var os2 = new B().u16(4).i16(G.adv).u16(400).u16(5).u16(0);
    [650, 600, 0, 75, 650, 600, 0, 350, 50, 250].forEach(function (v) { os2.i16(v); });
    os2.i16(0); for (i = 0; i < 10; i++) os2.u8(0);
    os2.u32(0).u32(0x02000000).u32(0).u32(0).tag('SMLP').u16(0x40).u16(0xFE0F).u16(0xFFFF).i16(asc).i16(-dsc).i16(0).u16(asc).u16(dsc).u32(1).u32(0)
      .i16(0).i16(Math.round(r * U)).u16(0).u16(32).u16(1);
    var post = new B().u32(0x30000).u32(0).i16(-100).i16(50).u32(0).u32(0).u32(0).u32(0).u32(0);
    var nofn = [[1, 'SM Loppa'], [2, 'Regular'], [3, 'SM Loppa ' + r], [4, 'SM Loppa'], [5, 'Version 1.000'], [6, 'SMLoppa']];
    var name = new B(), str = new B(), off = 0;
    name.u16(0).u16(nofn.length).u16(6 + nofn.length * 12);
    nofn.forEach(function (n) {
      name.u16(3).u16(1).u16(0x409).u16(n[0]).u16(n[1].length * 2).u16(off);
      for (var i = 0; i < n[1].length; i++) str.u16(n[1].charCodeAt(i));
      off += n[1].length * 2;
    });
    name.a = name.a.concat(str.a);
    var toflur = [['OS/2', os2], ['cmap', cmap], ['glyf', g], ['head', head], ['hhea', hhea], ['hmtx', hmtx], ['loca', loca], ['maxp', maxp], ['name', name], ['post', post]];
    var n = toflur.length, out = new B().u32(0x10000).u16(n).u16(128).u16(3).u16(n * 16 - 128), stadur = 12 + n * 16, gogn = [], headStadur = 0;
    function summa(a) { var s = 0; for (var i = 0; i < a.length; i += 4) s = (s + (((a[i] << 24) | ((a[i + 1] || 0) << 16) | ((a[i + 2] || 0) << 8) | (a[i + 3] || 0)) >>> 0)) >>> 0; return s; }
    toflur.forEach(function (t) {
      var lengd = t[1].a.length; t[1].pad();
      if (t[0] === 'head') headStadur = stadur;
      out.tag(t[0]).u32(summa(t[1].a)).u32(stadur).u32(lengd);
      gogn = gogn.concat(t[1].a); stadur += t[1].a.length;
    });
    var allt = out.a.concat(gogn), adj = (0xB1B0AFBA - summa(allt)) >>> 0;
    allt[headStadur + 8] = adj >>> 24; allt[headStadur + 9] = (adj >>> 16) & 255; allt[headStadur + 10] = (adj >>> 8) & 255; allt[headStadur + 11] = adj & 255;
    return new Uint8Array(allt).buffer;
  }
  /* adds the paw (U+1F43E, U+FE0F) to every web font face on the page: one FontFace per face, same family and
   * descriptors, so the browser takes the paw from the line's own family (and its cap height) */
  /* Only on a page that asks (the kit on a paw line, the workshop app's engine pages): a page that never calls it is exactly as
   * before (sm-husnumer.js leturSynt counts any loaded face of a family as "the font is shown"). After the first call, faces
   * that start loading later get the paw too. */
  var loppaSkrad = {}, loppaTtfSkyndi = {}, loppaVirk = false;
  function loppaVafri() {
    if (!D || !D.fonts || !W.FontFace || !D.fonts.forEach) return 0;
    if (!loppaVirk) {
      loppaVirk = true;
      try {
        if (D.fonts.addEventListener) D.fonts.addEventListener('loading', function () { loppaVafri(); });
        if (W.addEventListener) W.addEventListener('load', function () { loppaVafri(); });
      } catch (eL) { }
    }
    var ny = [];
    try {
      D.fonts.forEach(function (f) {
        if (f.__smLoppa) return;
        var fam = String(f.family || '').replace(/["']/g, '').trim(), k = fam.toLowerCase() + '|' + f.weight + '|' + f.style + '|' + f.stretch;
        if (!fam || loppaSkrad[k]) return;
        loppaSkrad[k] = 1; ny.push([fam, f]);
      });
    } catch (e) { return 0; }
    ny.forEach(function (x) {
      try {
        var r = loppaHlutfall(x[0], String(x[1].weight).split(' ')[0]);
        var buf = loppaTtfSkyndi[r] || (loppaTtfSkyndi[r] = loppaTtf(r));
        var ff = new W.FontFace(x[0], buf.slice(0), { weight: x[1].weight, style: x[1].style, stretch: x[1].stretch, unicodeRange: 'U+1F43E, U+FE0F', display: 'block' });
        ff.__smLoppa = 1; D.fonts.add(ff); if (ff.load) ff.load()['catch'](function () { });
      } catch (e) { }
    });
    return ny.length;
  }

  /* Lays out one line like Chrome does: kerning on, optional ligatures only when letter-spacing
   * is 0, letter-spacing added after every glyph (the trailing one counts in the width). */
  function uppsetning(L, t) {
    var texti = nfc(t.texti).replace(/[\r\n\t]+/g, ' ');
    var cp = kodapunktar(texti).filter(function (c) { return !OSYNILEGIR.test(c); });
    var mm = t.mm, sc = mm / L.upem, ls = (t.stafabil || 0) * mm, vantar = [], gf = !!(LETUR[L.id] && LETUR[L.id].gf) && t.gfSvid !== false;
    var lp = null;
    var gl = cp.map(function (c, i) {
      if (erLoppa(c)) { lp = lp || loppaGlyf(loppaR(L)); return { g: 0, c: i, n: 1, bil: false, s: 'loppa' + i, loppa: lp }; }
      var bil = BIL.test(c), g = L.font.charToGlyphIndex(bil ? ' ' : c);
      if (bil && !g) g = L.font.charToGlyphIndex(c);
      if (!g && !bil) vantar.push(c);
      return { g: g, c: i, n: 1, bil: bil, s: gf ? gfSvid(c) : 0 };
    });
    if (vantar.length) throw villa('stafur-vantar', L.id + ' ' + vantar.join(''));
    var liga = t.bandstafir != null ? !!t.bandstafir : !ls;
    if (L.rlig.length) gl = beitaLig(L, L.rlig, gl);
    if (liga && L.liga.length) gl = beitaLig(L, L.liga, gl);
    var x = 0, i, adv = [], plac = [];
    for (i = 0; i < gl.length; i++) { adv.push(gl[i].loppa ? gl[i].loppa.adv * L.upem / LOPPA_UPM : (L.font.glyphs.get(gl[i].g).advanceWidth || 0)); plac.push(0); }
    if (t.kerning !== false) {
      for (i = 0; i + 1 < gl.length; i++) {
        if (gl[i].s !== gl[i + 1].s) continue;
        var k = kerna(L, gl[i].g, gl[i + 1].g);
        adv[i] += k.a1; plac[i] += k.p1; adv[i + 1] += k.a2; plac[i + 1] += k.p2;
        if (k.v2) i++;
      }
    }
    var stafir = (t.stafir && t.stafir.length === cp.length) ? t.stafir : null;
    if (t.stafir && !stafir) throw villa('spec', 'stafir ' + t.stafir.length + ' != ' + cp.length);
    for (i = 0; i < gl.length; i++) {
      gl[i].x = stafir ? stafir[gl[i].c] : x + plac[i] * sc;
      gl[i].w = adv[i] * sc;
      x += adv[i] * sc + ls;
    }
    return { gl: gl, breidd: x, sc: sc, algild: !!stafir };
  }
  function textiCmds(L, t) {
    var u = uppsetning(L, t), gl = u.gl, shapes = [], i;
    for (i = 0; i < gl.length; i++) {
      if (gl[i].bil) continue;
      if (gl[i].loppa) { shapes = shapes.concat(loppaCmds(gl[i].loppa, gl[i].x, t.mm)); continue; }
      var p = L.font.glyphs.get(gl[i].g).getPath(gl[i].x, 0, t.mm);
      var cmds = p.commands.map(function (c) {
        if (c.type === 'Z') return { t: 'Z' };
        if (c.type === 'C') return { t: 'C', x1: c.x1, y1: c.y1, x2: c.x2, y2: c.y2, x: c.x, y: c.y };
        if (c.type === 'Q') return { t: 'Q', x1: c.x1, y1: c.y1, x: c.x, y: c.y };
        return { t: c.type, x: c.x, y: c.y };
      });
      if (cmds.length) shapes.push(cmds);
    }
    var j = t.jofnun || 'vinstri', x0 = 0;
    if (j === 'midja') x0 = -u.breidd / 2;
    else if (j === 'haegri') x0 = -u.breidd;
    else if (j === 'blekmidja' && shapes.length) {
      var lo = 1e9, hi = -1e9;
      shapes.forEach(function (s) { flatten(s).forEach(function (p) { p.forEach(function (q) { if (q[0] < lo) lo = q[0]; if (q[0] > hi) hi = q[0]; }); }); });
      x0 = -(lo + hi) / 2;
    }
    var sx = tala(t.kreista) && t.kreista > 0 ? t.kreista : 1, ax = tala(t.kreistaUm) ? t.kreistaUm : t.x;
    var m = [1, 0, 0, 1, u.algild ? 0 : t.x + x0, t.y];
    if (sx !== 1) m = mul([sx, 0, 0, 1, ax * (1 - sx), 0], m);
    if (t.fylki) m = mul(fylki(t.fylki), m);
    return { shapes: shapes.map(function (s) { return umbreytaCmds(s, m); }), breidd: u.breidd * sx };
  }

  /* ---------------------------------------------------------------- spec */
  var GERDIR = { texti: 1, rett: 1, hringur: 1, sporaskja: 1, slod: 1, mynd: 1 };
  function stadla(spec) {
    if (!spec || typeof spec !== 'object') throw villa('spec', 'engin forskrift');
    if (!tala(spec.w) || !tala(spec.h) || spec.w <= 0 || spec.h <= 0 || spec.w > 3000 || spec.h > 3000) throw villa('spec', 'w/h');
    if (!spec.hlutir || !spec.hlutir.length) throw villa('spec', 'hlutir');
    return spec.hlutir.map(function (e, i) {
      if (!e || !GERDIR[e.gerd]) throw villa('spec', 'gerd #' + i);
      var lag = e.lag === 'SKERA' ? 'SKERA-YTRA' : (e.lag || (e.gerd === 'mynd' ? 'GRAFA-MYND' : 'GRAFA'));
      if (LOG_ROD.indexOf(lag) < 0) throw villa('spec', 'lag #' + i);
      if (e.gerd === 'mynd' && lag !== 'GRAFA-MYND') throw villa('spec', 'mynd a GRAFA-MYND #' + i);
      if (e.gerd === 'texti' && String(e.texti || '').replace(/\s+/g, '')) {
        if (!LETUR[e.letur] && !leturGogn[e.letur]) throw villa('letur-vantar', String(e.letur));
        if (!tala(e.mm) || e.mm <= 0 || !tala(e.x) || !tala(e.y)) throw villa('spec', 'texti #' + i);
      }
      var n = {}; for (var k in e) if (e.hasOwnProperty(k)) n[k] = e[k];
      n.lag = lag; n.i = i;
      return n;
    });
  }
  function leturISpec(spec) {
    var ids = [];
    ((spec && spec.hlutir) || []).forEach(function (e) {
      if (e && e.gerd === 'texti' && String(e.texti || '').replace(/\s+/g, '') && ids.indexOf(e.letur) < 0) ids.push(e.letur);
    });
    return ids;
  }
  function getur(spec) {
    try { stadla(spec); } catch (e) { return false; }
    var ids = leturISpec(spec);
    for (var i = 0; i < ids.length; i++) if (!hefurLetur(ids[i])) return false;
    return true;
  }
  function fyrstuOrd(spec) {
    if (spec.ord) return ascii(spec.ord).slice(0, 24).replace(/-+$/, '');
    var t = null;
    (spec.hlutir || []).some(function (e) { if (e && e.gerd === 'texti' && String(e.texti || '').trim()) { t = e.texti; return true; } return false; });
    if (!t) return '';
    var o = ascii(t).split('-').filter(Boolean), s = '';
    for (var i = 0; i < o.length && i < 3; i++) { var n = s ? s + '-' + o[i] : o[i]; if (n.length > 24) break; s = n; }
    return s || (o[0] || '').slice(0, 24);
  }
  function nafnSkrar(spec) {
    spec = spec || {};
    var st = spec.staerd != null && spec.staerd !== '' ? ascii(spec.staerd) : (tala(spec.w) && tala(spec.h) ? Math.round(spec.w) + 'x' + Math.round(spec.h) : '');
    var hl = [ascii(spec.vara) || 'skilti', ascii(spec.efni), st, fyrstuOrd(spec)].filter(Boolean);
    var s = hl.join('-').replace(/-+/g, '-');
    if (s.length > 80) s = s.slice(0, 80).replace(/-[^-]*$/, '');
    return (s || 'skilti') + '.svg';
  }
  function json(spec) {
    var o = { v: SNID, vel: UTGAFA }, k;
    for (k in spec) if (spec.hasOwnProperty(k) && k !== 'v' && k !== 'vel') o[k] = spec[k];
    o.hlutir = (spec.hlutir || []).map(function (e) {
      var n = {}, k2;
      for (k2 in e) if (e.hasOwnProperty(k2)) n[k2] = e[k2];
      if (n.gerd === 'mynd') { delete n.src; n.mynd = e.nafn || 'mynd'; }
      return n;
    });
    var s;
    try { s = JSON.stringify(o); } catch (e) { s = JSON.stringify({ v: SNID, vel: UTGAFA, vara: spec.vara, villa: 'json' }); }
    if (s.length > HAMARK_JSON) {
      o.hlutir = o.hlutir.map(function (e) { if (e.d && e.d.length > 2000) { e = afrita(e); e.d = '(' + e.d.length + ')'; } return e; });
      o.styttur = 1; s = JSON.stringify(o);
      if (s.length > HAMARK_JSON) s = JSON.stringify({ v: SNID, vel: UTGAFA, vara: spec.vara, efni: spec.efni, staerd: spec.staerd, styttur: 1 });
    }
    return s;
  }

  /* raster images -> PNG data URL */
  function myndTilPng(e) {
    var src = e.src;
    return new Promise(function (res, rej) {
      if (!src) { rej(villa('mynd', 'src vantar')); return; }
      if (typeof src === 'string' && /^data:image\/png;base64,/.test(src) && !e.maski) { res(src); return; }
      var teikna = function (img, w, h) {
        try {
          var c = D.createElement('canvas'); c.width = w; c.height = h;
          var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
          if (e.maski) {
            var d = x.getImageData(0, 0, w, h), p = d.data;
            for (var i = 0; i < p.length; i += 4) { p[i] = p[i + 1] = p[i + 2] = 0; }
            x.putImageData(d, 0, 0);
          }
          res(c.toDataURL('image/png'));
        } catch (er) { rej(villa('mynd', er && er.message)); }
      };
      if (src.getContext) { teikna(src, src.width, src.height); return; }
      if (src.naturalWidth) { teikna(src, src.naturalWidth, src.naturalHeight); return; }
      if (src.width && src.height && !(typeof src === 'string') && !(W.Blob && src instanceof W.Blob)) { teikna(src, src.width, src.height); return; }
      var url = (W.Blob && src instanceof W.Blob) ? W.URL.createObjectURL(src) : String(src);
      var img = new W.Image();
      img.onload = function () { teikna(img, img.naturalWidth, img.naturalHeight); if (url !== src) W.URL.revokeObjectURL(url); };
      img.onerror = function () { rej(villa('mynd', 'hladst ekki')); };
      img.src = url;
    });
  }

  /* ---------------------------------------------------------------- building */
  function hlutur(e, fontar) {
    var M = e.fylki ? fylki(e.fylki) : null, nat = null, cmds = null, shapes;
    if (e.gerd === 'texti') {
      if (!String(e.texti || '').replace(/\s+/g, '')) return null;
      var r = textiCmds(fontar[e.letur], e);
      shapes = r.shapes;
      return { shapes: shapes, nat: shapes.length ? '<path d="' + cmdsTilD(shapes) + '"/>' : '', gat: !!e.gat };
    }
    if (e.gerd === 'rett') {
      var rx = tala(e.r) ? e.r : 0, ry = tala(e.ry) ? e.ry : rx;
      cmds = cmdsRett(e.x, e.y, e.w, e.h, rx, ry);
      if (!M) nat = '<rect x="' + f3(e.x) + '" y="' + f3(e.y) + '" width="' + f3(e.w) + '" height="' + f3(e.h) + '"' + (rx > 0 ? ' rx="' + f3(rx) + '" ry="' + f3(ry) + '"' : '') + '/>';
    } else if (e.gerd === 'hringur') {
      cmds = cmdsSporaskja(e.cx, e.cy, e.r, e.r);
      if (!M) nat = '<circle cx="' + f3(e.cx) + '" cy="' + f3(e.cy) + '" r="' + f3(e.r) + '"/>';
    } else if (e.gerd === 'sporaskja') {
      cmds = cmdsSporaskja(e.cx, e.cy, e.rx, e.ry);
      if (!M) nat = '<ellipse cx="' + f3(e.cx) + '" cy="' + f3(e.cy) + '" rx="' + f3(e.rx) + '" ry="' + f3(e.ry) + '"/>';
    } else if (e.gerd === 'slod') {
      cmds = lesaD(e.d);
    }
    if (M) cmds = umbreytaCmds(cmds, M);
    if (!nat) nat = '<path d="' + cmdsTilD([cmds]) + '"/>';
    return { shapes: [cmds], nat: nat, gat: !!e.gat };
  }
  /* Gives the browser a turn (input, painting) between slices of the build: scheduler.yield, else a
   * MessageChannel message (not throttled like timers in a background tab), else setTimeout. */
  function bidaVafra() {
    return new Promise(function (r) {
      try { if (W.scheduler && typeof W.scheduler.yield === 'function') { W.scheduler.yield().then(r, r); return; } } catch (e) { }
      if (W.MessageChannel) { var m = new W.MessageChannel(); m.port1.onmessage = function () { m.port1.onmessage = null; r(); }; m.port2.postMessage(0); return; }
      setTimeout(r, 0);
    });
  }
  var SNEID = 8; /* ms of work per slice before the browser gets a turn */
  /* runs the steps in order, in slices of about SNEID ms; athuga() throws when the time is up */
  function iSneidum(skref, athuga) {
    var i = 0;
    return new Promise(function (res, rej) {
      (function lota() {
        var t = nu();
        try {
          athuga();
          while (i < skref.length) {
            skref[i++]();
            if (i < skref.length && nu() - t >= SNEID) { bidaVafra().then(lota); return; }
          }
        } catch (e) { rej(e); return; }
        res();
      })();
    });
  }
  /* nonzero union of one group; keeps the exact curves when nothing overlaps (as the approved samples).
   * Same operations in the same order as one synchronous pass, split into steps so a large group (crosses:
   * traced symbols and name) does not hold the page: one step per shape, the union, the difference, the path. */
  function sameina(atridi, athuga) {
    var pos = [], neg = [], summa = 0, merkt = 0, gat = false, U = null, uA = 0, V = null, ut = null, skref = [];
    atridi.forEach(function (a) {
      a.shapes.forEach(function (cmds) {
        skref.push(function () {
          var pl = flatten(cmds); if (!pl.length) return;
          if (a.gat) { neg = neg.concat(pl); gat = true; return; }
          pos = pos.concat(pl); summa += flatarmal(klippa('sameina', pl)); merkt += Math.abs(signedArea(pl));
        });
      });
    });
    skref.push(function () {
      if (!pos.length) { ut = ''; return; }
      U = klippa('sameina', pos); uA = flatarmal(U);
      var skorun = gat || Math.abs(summa - uA) > 1e-3 || Math.abs(merkt - uA) > 1e-3;
      if (!skorun) ut = atridi.map(function (a) { return a.nat; }).join('');
    });
    skref.push(function () { if (ut === null) V = gat ? klippa('mismunur', pos, neg) : U; });
    skref.push(function () { if (ut === null) ut = '<path d="' + polysTilD(V) + '"/>'; });
    return iSneidum(skref, athuga).then(function () { return ut; });
  }
  function dags() { var d = new Date(), p = function (n) { return (n < 10 ? '0' : '') + n; }; return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()); }
  function lysingar(spec) {
    var l = spec.lysing, out = [];
    if (!l) return out;
    if (l.length != null && typeof l !== 'string') { for (var i = 0; i < l.length; i++) if (l[i] && l[i].length >= 2) out.push([l[i][0], l[i][1]]); }
    else if (typeof l === 'object') { for (var k in l) if (l.hasOwnProperty(k)) out.push([k, l[k]]); }
    return out.filter(function (x) { return x[1] != null && x[1] !== ''; });
  }
  /* The file, built in slices (iSneidum): outlines element by element, then each group's union, then
   * the text of the file. Resolves the SVG text; identical to building it in one pass. */
  function skrifa(spec, hlutir, fontar, myndir, nafn, athuga) {
    var hopar = {}, rod = [], skref = [];
    hlutir.forEach(function (e) {
      skref.push(function () {
        var key = e.lag + '|' + (e.hopur || '');
        if (!hopar[key]) { hopar[key] = { lag: e.lag, hopur: e.hopur || '', atridi: [] }; rod.push(key); }
        if (e.gerd === 'mynd') {
          if (myndir[e.i]) hopar[key].atridi.push({ mynd: '<image x="' + f3(e.x) + '" y="' + f3(e.y) + '" width="' + f3(e.w) + '" height="' + f3(e.h) + '" preserveAspectRatio="none" xlink:href="' + myndir[e.i] + '"' + (e.fylki ? ' transform="matrix(' + fylki(e.fylki).map(f3).join(' ') + ')"' : '') + '/>' });
          return;
        }
        var h = hlutur(e, fontar);
        if (h) hopar[key].atridi.push(h);
      });
    });
    var lagEfni = {};
    return iSneidum(skref, athuga).then(function () {
      var p = Promise.resolve();
      rod.forEach(function (key) {
        p = p.then(function () {
          var H = hopar[key];
          if (!H.atridi.length) return;
          var inni;
          if (H.lag === 'GRAFA-MYND') inni = H.atridi.map(function (a) { return a.mynd; }).join('\n');
          else if (SAMEINA[H.lag]) inni = sameina(H.atridi, athuga);
          else inni = H.atridi.map(function (a) { return a.nat; }).join('');
          return Promise.resolve(inni).then(function (inni) {
            if (!inni) return;
            if (H.hopur) inni = '<g id="' + escXml(H.lag + '-' + H.hopur) + '">' + inni + '</g>';
            (lagEfni[H.lag] = lagEfni[H.lag] || []).push(inni);
          });
        });
      });
      return p;
    }).then(function () { return skrifaSkra(spec, lagEfni, fontar, nafn); });
  }
  function skrifaSkra(spec, lagEfni, fontar, nafn) {
    var lag = function (id, merki, attr, efni) { return '<g id="' + id + '" inkscape:groupmode="layer" inkscape:label="' + merki + '"' + (attr ? ' ' + attr : '') + '>\n' + efni + '\n</g>\n'; };
    var body = '';
    if (lagEfni['GRAFA-MYND']) body += lag('GRAFA-MYND', '0-GRAFA-MYND', '', lagEfni['GRAFA-MYND'].join('\n'));
    if (lagEfni.GRAFA) body += lag('GRAFA', '1-GRAFA', ATTR.GRAFA, lagEfni.GRAFA.join('\n'));
    if (lagEfni['RAMMI-LARETT']) body += lag('RAMMI-LARETT', '1-RAMMI-LARETT', ATTR.RAMMI, lagEfni['RAMMI-LARETT'].join('\n'));
    if (lagEfni['RAMMI-LODRETT-90']) body += lag('RAMMI-LODRETT-90', '1-RAMMI-LODRETT-90', ATTR.RAMMI, lagEfni['RAMMI-LODRETT-90'].join('\n'));
    if (lagEfni.LINA) body += lag('LINA', '2-LINA', ATTR.LINA, lagEfni.LINA.join('\n'));
    if (lagEfni['SKERA-INNRA'] || lagEfni['SKERA-YTRA']) {
      var sk = '';
      if (lagEfni['SKERA-INNRA']) sk += '<g id="SKERA-INNRA">' + lagEfni['SKERA-INNRA'].join('\n') + '</g>';
      if (lagEfni['SKERA-YTRA']) sk += (sk ? '\n' : '') + '<g id="SKERA-YTRA">' + lagEfni['SKERA-YTRA'].join('\n') + '</g>';
      body += lag('SKERA', '3-SKERA', ATTR.SKERA, sk);
    }
    if (lagEfni.UTLINA) body += lag('UTLINA', '9-UTLINA', ATTR.UTLINA, lagEfni.UTLINA.join('\n'));
    if (!body) throw villa('tomt', 'ekkert ad teikna');

    var ids = Object.keys(fontar);
    var meta = [['skra', nafn], ['vara', spec.vara || ''], ['efni', spec.efni || ''], ['staerd', (spec.staerd ? spec.staerd + ', ' : '') + f3(spec.w) + ' x ' + f3(spec.h) + ' mm']];
    if (spec.snid) meta.push(['snid', spec.snid]);
    meta = meta.concat(lysingar(spec));
    ids.forEach(function (id) { var L = LETUR[id] || {}; meta.push(['letur', id + ' = ' + (L.f || id) + ' ' + (L.w || '') + (L.i ? ' italic' : '') + ' (' + (L.u || '') + ')']); });
    meta.push(['einingar', 'mm (1 = 1 mm), 0.01 mm grid, merged outlines as polygons within 0.02 mm; text = outlines']);
    meta.push(['log', 'GRAFA fill #000000 | LINA stroke #0000ff 0.1 | SKERA stroke #ff0000 0.1, SKERA-INNRA > SKERA-YTRA' + (lagEfni['GRAFA-MYND'] ? ' | GRAFA-MYND png' : '') + (lagEfni['RAMMI-LARETT'] || lagEfni['RAMMI-LODRETT-90'] ? ' | RAMMI-LARETT fill #000000 0\u00b0, RAMMI-LODRETT-90 fill #000000 90\u00b0' : '') + (lagEfni.UTLINA ? ' | UTLINA #00b050 = placement only' : '')]);
    var s = '<?xml version="1.0" encoding="UTF-8"?>\n<!--\n  Skilti og merkingar - SMFram ' + UTGAFA + ' (' + SNID + '), ' + dags() + '\n';
    meta.forEach(function (m) { s += '  ' + escAthugasemd(m[0]) + ': ' + escAthugasemd(m[1]) + '\n'; });
    s += '-->\n';
    var titill = spec.titill || [spec.vara, spec.efni, spec.staerd].filter(Boolean).join(' ');
    s += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="' + f3(spec.w) + 'mm" height="' + f3(spec.h) + 'mm" viewBox="0 0 ' + f3(spec.w) + ' ' + f3(spec.h) + '">\n';
    s += '<title>' + escXml(titill || nafn) + '</title>\n' + body + '</svg>\n';
    return s;
  }

  function bua(spec, st) {
    st = st || {};
    var tima = tala(st.tima) && st.tima > 0 ? st.tima : TIMI, t0 = nu(), frest = t0 + tima, lokid = false;
    return new Promise(function (res, rej) {
      var tmr = setTimeout(function () { if (!lokid) { lokid = true; rej(villa('timi', tima + ' ms')); } }, tima);
      var athuga = function () { if (lokid || nu() > frest) throw villa('timi', tima + ' ms'); };
      var hlutir, fontar = {}, myndir = {}, rodL = [];
      Promise.resolve().then(function () {
        hlutir = stadla(spec);
        var ids = rodL = leturISpec(spec), bid = [hladaClipper()];
        ids.forEach(function (id) {
          if (!hefurLetur(id)) throw villa('letur-vantar', id);
          bid.push(hladaLetur(id).then(function (L) { fontar[id] = L; }));
        });
        hlutir.forEach(function (e) {
          if (e.gerd !== 'mynd') return;
          if (!e.src && st.anMynda) return;
          bid.push(myndTilPng(e).then(function (u) { myndir[e.i] = u; }));
        });
        return Promise.all(bid);
      }).then(function () {
        athuga();
        /* fonts in the order of the spec, not in the order they arrived: the same spec gives the same file */
        var f2 = {}; rodL.forEach(function (id) { if (fontar[id]) f2[id] = fontar[id]; }); fontar = f2;
        var nafn = nafnSkrar(spec);
        return skrifa(spec, hlutir, fontar, myndir, nafn, athuga).then(function (svg) {
          athuga();
          return { svg: svg, nafn: nafn, letur: Object.keys(fontar), bytes: svg.length };
        });
      }).then(function (r) {
        if (lokid) return; lokid = true; clearTimeout(tmr); r.ms = Math.round(nu() - t0); res(r);
      }, function (e) {
        if (lokid) return; lokid = true; clearTimeout(tmr); rej(e instanceof Error ? e : villa('villa', String(e)));
      });
    });
  }

  /* unique per line: 8 random bytes (crypto) + the time, base 36 */
  function nyttNr() {
    var s = '';
    try { var a = new W.Uint32Array(2); W.crypto.getRandomValues(a); s = a[0].toString(36) + a[1].toString(36); } catch (e) { }
    if (!s) s = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    return s.slice(0, 12) + '-' + new Date().getTime().toString(36);
  }
  function hefur(fd, k) { try { return !!(fd.has && fd.has(k)); } catch (e) { return false; } }
  /* Appends properties[_framleidsla] (JSON, at once) and properties[_Framlei\u00f0sluskr\u00e1] (the SVG, when it
   * is built within the time budget) to a FormData for /cart/add. Never rejects, never throws. */
  function baetaVid(fd, spec, st) {
    st = st || {};
    var t0 = nu(), pre = st.forskeyti || 'properties';
    var kJ = pre + '[' + JSON_LYKILL + ']', kS = pre + '[' + SKRA_LYKILL + ']';
    try {
      if (st.json !== false && !hefur(fd, kJ)) {
        var j = st.json != null ? (typeof st.json === 'string' ? st.json : JSON.stringify(st.json)) : (spec ? json(spec) : '');
        if (j) fd.append(kJ, j);
      }
    } catch (e) { try { W.console && W.console.warn('[SMFram] _framleidsla: ' + (e && e.message)); } catch (e2) { } }
    if (!spec || st.skra === false) return Promise.resolve({ formData: fd, skra: false });
    var p;
    try { p = bua(spec, { tima: st.tima, anMynda: st.anMynda }); } catch (e) { p = Promise.reject(e); }
    return p.then(function (r) {
      var blob = new W.Blob([r.svg], { type: 'image/svg+xml' }), kN = pre + '[' + NR_LYKILL + ']', nr = null;
      fd.append(kS, blob, r.nafn);
      if (!hefur(fd, kN)) { nr = nyttNr(); fd.append(kN, nr); }
      return { formData: fd, skra: true, nafn: r.nafn, bytes: r.bytes, nr: nr, ms: Math.round(nu() - t0) };
    }).then(null, function (e) {
      try { W.console && W.console.warn('[SMFram] framleidsluskra fylgir ekki (' + ((e && e.kodi) || 'villa') + '): ' + (e && e.message ? e.message : e)); } catch (e2) { }
      return { formData: fd, skra: false, villa: (e && e.kodi) || 'villa', ms: Math.round(nu() - t0) };
    });
  }
  /* ---------------------------------------------------------------- the add itself, bounded
   * SMFram.senda(fd, st) posts the FormData to /cart/add.js like fetch and resolves to a Response.
   * Without a production file in it, it is plain fetch, exactly as before. With a file:
   * - the add must answer within st.tima (8 s); when the whole file is already uploaded, Shopify gets
   *   4 s more, since it is working on it;
   * - no answer, a network error or a 5xx: /cart.js is read and the line looked up by its unique hidden
   *   property _framleidsla_nr (baetaVid adds it with the file). Found: resolves with that line (status
   *   200), so the line is never added twice. Not found: sent once more WITHOUT the file (the JSON and
   *   everything else kept). If /cart.js cannot be read, nothing is sent again and it rejects like fetch
   *   does on a network error;
   * - a 4xx (except 429): Shopify refused it and added nothing: sent once more without the file.
   * response.smfram = { leid: 'skra'|'fannst'|'an-skrar'|'beint', astaeda, ms, tilraunir }. */
  function lyklarMed(fd, endir) {
    var out = [];
    try { fd.forEach(function (v, k) { if (k.slice(-endir.length) === endir) out.push([k, v]); }); } catch (e) { }
    return out;
  }
  function anSkrar(fd) {
    var n = new W.FormData(), endir = '[' + SKRA_LYKILL + ']';
    fd.forEach(function (v, k) {
      if (k.slice(-endir.length) === endir) return;
      if (W.Blob && v instanceof W.Blob) n.append(k, v, v.name || 'skra'); else n.append(k, v);
    });
    return n;
  }
  function svar(status, texti, tegund) {
    texti = texti == null ? '' : String(texti);
    try { return new W.Response(texti, { status: status, headers: { 'Content-Type': tegund || 'application/json' } }); } catch (e) { }
    return {
      ok: status >= 200 && status < 300, status: status, headers: { get: function () { return tegund || 'application/json'; } },
      text: function () { return Promise.resolve(texti); }, json: function () { return Promise.resolve(JSON.parse(texti)); }, clone: function () { return this; }
    };
  }
  /* one XMLHttpRequest (its upload events tell whether Shopify has the whole file):
   * resolves { status, texti, tegund } or { villa: 'net' | 'timi', upphlodid }.
   * lengi: the body also carries the customer's own files (photo, logo). Those went up with no time
   * limit before SMFram, so the limit then only counts while the upload stands still: the request is
   * cut when nothing has gone up for `tima` ms, never while a slow line is still sending the photo. */
  function beidni(adferd, url, fd, tima, naad, lengi) {
    return new Promise(function (res) {
      var x, lokid = false, upp = false, t1 = null, t2 = null, sidast = nu();
      var buid = function (r) { if (lokid) return; lokid = true; clearTimeout(t1); clearTimeout(t2); res(r); };
      try {
        x = new W.XMLHttpRequest();
        x.open(adferd, url, true);
        x.setRequestHeader('Accept', 'application/json');
        if (fd && x.upload) {
          x.upload.onload = function () { upp = true; sidast = nu(); };
          x.upload.onprogress = function (e) { sidast = nu(); if (e && e.lengthComputable && e.total && e.loaded >= e.total) upp = true; };
        }
        x.onload = function () { if (!x.status) buid({ villa: 'net', upphlodid: upp }); else buid({ status: x.status, texti: x.responseText, tegund: x.getResponseHeader('Content-Type') }); };
        x.onerror = function () { buid({ villa: 'net', upphlodid: upp }); };
        x.onabort = function () { buid({ villa: 'timi', upphlodid: upp }); };
        x.send(fd || null);
      } catch (e) { buid({ villa: 'net', upphlodid: false }); return; }
      var haetta = function () { if (lokid) return; var u = upp; try { x.abort(); } catch (e) { } buid({ villa: 'timi', upphlodid: u }); };
      var athuga = function () {
        if (lokid) return;
        if (upp) { if (naad) t2 = setTimeout(haetta, naad); else haetta(); return; }
        var kyrrt = nu() - sidast;
        if (lengi && fd && kyrrt < tima) { t1 = setTimeout(athuga, Math.min(1000, Math.max(250, tima - kyrrt))); return; }
        haetta();
      };
      t1 = setTimeout(athuga, tima);
    });
  }
  /* bytes of the files in a FormData: [all files, the customer's own files (not the production file)] */
  function skraBaeti(fd) {
    var alls = 0, adrar = 0, endir = '[' + SKRA_LYKILL + ']';
    try {
      fd.forEach(function (v, k) {
        if (!(W.Blob && v instanceof W.Blob)) return;
        alls += v.size || 0;
        if (k.slice(-endir.length) !== endir) adrar += v.size || 0;
      });
    } catch (e) { }
    return [alls, adrar];
  }
  function bida(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  /* lines that carry one of the tokens: resolves the lines ([] = not there) or null (cart unreadable).
   * skipti > 1: looks again after 1.5 s (Shopify may still be finishing a request it fully received) */
  function leitaIKorfu(karfa, nrs, skipti) {
    var n = 0;
    var einu = function () {
      return beidni('GET', karfa + (karfa.indexOf('?') < 0 ? '?' : '&') + '_=' + new Date().getTime(), null, KARFA_TIMI, 0).then(function (r) {
        if (!r.status || r.status >= 300) return null;
        var j; try { j = JSON.parse(r.texti); } catch (e) { return null; }
        return ((j && j.items) || []).filter(function (it) { return it && it.properties && nrs.indexOf(String(it.properties[NR_LYKILL])) >= 0; });
      });
    };
    var lykkja = function () {
      n++;
      return einu().then(function (l) {
        if (l && l.length) return l;
        if (n < skipti) return bida(1500).then(lykkja);
        return l;
      });
    };
    return lykkja();
  }
  /* the cart drawer's sections (sections=...) for a found line, as /cart/add.js would have sent them */
  function kaflar(fd, lina) {
    var k = null, u = null;
    try { k = fd.get('sections'); u = fd.get('sections_url'); } catch (e) { }
    if (!k) return Promise.resolve(lina);
    u = String(u || (W.location && W.location.pathname) || '/');
    return beidni('GET', u + (u.indexOf('?') < 0 ? '?' : '&') + 'sections=' + encodeURIComponent(k), null, KARFA_TIMI, 0).then(function (r) {
      try { if (r.status === 200) lina.sections = JSON.parse(r.texti); } catch (e) { }
      return lina;
    });
  }
  function senda(fd, st) {
    st = st || {};
    var t0 = nu(), rt = W.routes || {};
    var url = st.url || ((rt.cart_add_url || '/cart/add') + '.js');
    var karfa = st.karfa || ((rt.cart_url || '/cart') + '.js');
    var skrar = lyklarMed(fd, '[' + SKRA_LYKILL + ']');
    var nrs = lyklarMed(fd, '[' + NR_LYKILL + ']').map(function (a) { return String(a[1]); });
    var tima = tala(st.tima) && st.tima > 0 ? st.tima : SENDA_TIMI, naad = tala(st.naad) && st.naad >= 0 ? st.naad : SENDA_NAAD;
    var merkja = function (r, leid, astaeda, n) { try { r.smfram = { leid: leid, astaeda: astaeda || '', ms: Math.round(nu() - t0), tilraunir: n }; } catch (e) { } return r; };
    /* Shopify answers 2 to 4.3 s after the whole body is up (measured 2026-09-28: 0.6 MB 1.9 s, 4.6 MB 2.4 to
     * 4.3 s, 16 MB 3.6 to 3.8 s), so the wait after the upload grows by 0.5 s per MB. The customer's own files
     * (lengi) are never cut while they are still going up. */
    var bt = skraBaeti(fd), lengi = bt[1] > 0, MB = 1048576;
    if (!skrar.length || !W.XMLHttpRequest || !W.FormData) {
      return W.fetch(url, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return merkja(r, 'beint', '', 1); });
    }
    var fannst = function (linur, astaeda, n) {
      var fjoldi = false;
      try { fd.forEach(function (v, k) { if (k.indexOf('items[') === 0) fjoldi = true; }); } catch (e) { }
      return kaflar(fd, fjoldi ? { items: linur } : linur[0]).then(function (l) { return merkja(svar(200, JSON.stringify(l)), 'fannst', astaeda, n); });
    };
    var ovist = function (astaeda) {
      try { if (W.console) W.console.warn('[SMFram] karfan svarar ekki (' + astaeda + ')'); } catch (e) { }
      /* the page may show this message to the customer, so it is plain Icelandic */
      var e = new TypeError('Ekki n\u00e1\u00f0ist samband vi\u00f0 k\u00f6rfuna. Athuga\u00f0u nettenginguna og reyndu aftur.');
      e.kodi = 'net'; e.astaeda = astaeda; throw e;
    };
    var aftur = function (astaeda) {
      try { if (W.console) W.console.warn('[SMFram] framleidsluskra fylgir ekki (' + astaeda + '), sent aftur an skrar'); } catch (e) { }
      return beidni('POST', url, anSkrar(fd), ENDUR_TIMI, naad + Math.round(bt[1] / MB * 500), lengi).then(function (r) {
        if (r.status && (r.status < 500 || !nrs.length)) return merkja(svar(r.status, r.texti, r.tegund), 'an-skrar', astaeda, 2);
        if (!nrs.length) return ovist(astaeda + ', ' + r.villa);
        var a2 = astaeda + ', ' + (r.status ? 'villa ' + r.status : r.villa);
        return leitaIKorfu(karfa, nrs, (r.upphlodid || r.status) ? 2 : 1).then(function (l) {
          if (l && l.length) return fannst(l, a2, 2);
          if (r.status) return merkja(svar(r.status, r.texti, r.tegund), 'an-skrar', a2, 2);
          return ovist(a2);
        });
      });
    };
    var heilt = function (r) { try { JSON.parse(r.texti); return true; } catch (e) { return false; } };
    return beidni('POST', url, fd, tima, naad + Math.round(bt[0] / MB * 500), lengi).then(function (r) {
      if (r.status >= 200 && r.status < 300 && (heilt(r) || !nrs.length)) return merkja(svar(r.status, r.texti, r.tegund), 'skra', '', 1);
      if (r.status >= 200 && r.status < 300) r = { status: 0, villa: 'svar-brotid', upphlodid: true };
      if (r.status === 429) return merkja(svar(r.status, r.texti, r.tegund), 'skra', '429', 1);
      if (r.status >= 400 && r.status < 500) return aftur('hafnad ' + r.status);
      var astaeda = r.status ? 'villa ' + r.status : r.villa;
      if (!nrs.length) return r.status ? merkja(svar(r.status, r.texti, r.tegund), 'skra', astaeda, 1) : ovist(astaeda);
      return leitaIKorfu(karfa, nrs, (r.upphlodid || r.status) ? 2 : 1).then(function (l) {
        if (l === null) return ovist(astaeda);
        if (l.length) return fannst(l, astaeda, 1);
        return aftur(astaeda);
      });
    });
  }
  /* baetaVid + senda in one call: builds the file (st.tima, default 2.5 s), then adds the line
   * (st.sendaTimi, default 8 s). Resolves to the Response; response.smfram.skra = the file went in. */
  function baetaOgSenda(fd, spec, st) {
    st = st || {};
    var b = {}, k;
    for (k in st) if (st.hasOwnProperty(k) && k !== 'sendaTimi' && k !== 'url' && k !== 'karfa' && k !== 'naad') b[k] = st[k];
    return baetaVid(fd, spec, b).then(function (r) {
      return senda(fd, { url: st.url, karfa: st.karfa, tima: st.sendaTimi, naad: st.naad }).then(function (s) {
        try { if (s.smfram) { s.smfram.skra = !!r.skra && s.smfram.leid !== 'an-skrar'; s.smfram.bua = r; } } catch (e) { }
        return s;
      });
    });
  }
  /* {id, quantity, properties} (the JSON body of /cart/add.js) -> FormData */
  function fraJson(item, pre) {
    var fd = new W.FormData(), k;
    pre = pre || '';
    fd.append(pre ? pre + '[id]' : 'id', String(item.id));
    fd.append(pre ? pre + '[quantity]' : 'quantity', String(item.quantity == null ? 1 : item.quantity));
    if (item.selling_plan) fd.append(pre ? pre + '[selling_plan]' : 'selling_plan', String(item.selling_plan));
    var p = item.properties || {};
    for (k in p) if (p.hasOwnProperty(k) && p[k] != null) fd.append((pre ? pre + '[properties]' : 'properties') + '[' + k + ']', p[k]);
    return fd;
  }
  function forhlada(x) {
    var ids = typeof x === 'string' ? [x] : (x && x.length != null && !x.hlutir ? x : leturISpec(x));
    var go = function () {
      var bid = [hladaClipper()['catch'](function () { })];
      ids.forEach(function (id) { if (hefurLetur(id)) bid.push(hladaLetur(id)['catch'](function () { })); });
      return Promise.all(bid);
    };
    return new Promise(function (res) {
      if (W.requestIdleCallback) W.requestIdleCallback(function () { go().then(res); }, { timeout: 3000 });
      else setTimeout(function () { go().then(res); }, 200);
    });
  }
  /* CSS family + weight (+ italic) -> font id, with CSS weight matching over the shipped weights */
  function leturFyrir(fjolskylda, thykkt, skaletrad, naest) {
    var fam = String(fjolskylda || '').split(',')[0].replace(/["']/g, '').trim().toLowerCase();
    var w = +thykkt || 400, it = !!(skaletrad && skaletrad !== 'normal'), best = null, bestW = null;
    var kost = Object.keys(LETUR).filter(function (id) { var L = LETUR[id]; return (L.f.toLowerCase() === fam || (L.a && L.a.toLowerCase() === fam)) && !!L.i === it; });
    if (!kost.length) return null;
    var vv = kost.map(function (id) { return LETUR[id].w; });
    var velja = function (cands) { return cands.length ? cands[0] : null; };
    if (vv.indexOf(w) >= 0) bestW = w;
    else if (!naest) return null;
    else if (w >= 400 && w <= 500) {
      bestW = velja(vv.filter(function (v) { return v > w && v <= 500; }).sort(function (a, b) { return a - b; })) ||
        velja(vv.filter(function (v) { return v < w; }).sort(function (a, b) { return b - a; })) ||
        velja(vv.filter(function (v) { return v > 500; }).sort(function (a, b) { return a - b; }));
    } else if (w < 400) {
      bestW = velja(vv.filter(function (v) { return v < w; }).sort(function (a, b) { return b - a; })) || velja(vv.filter(function (v) { return v > w; }).sort(function (a, b) { return a - b; }));
    } else {
      bestW = velja(vv.filter(function (v) { return v > w; }).sort(function (a, b) { return a - b; })) || velja(vv.filter(function (v) { return v < w; }).sort(function (a, b) { return b - a; }));
    }
    kost.some(function (id) { if (LETUR[id].w === bestW) { best = id; return true; } return false; });
    return best;
  }

  /* ---------------------------------------------------------------- frames (1.2.0)
   * One geometry for the preview and the file (kit: SMVelSida.rammi). mm, plate origin top left.
   * linuRammi(W, H, g): ONE score line on LINA, g = { inset (3), insetY (inset), r (plate corner), form
   *   'rett'|'hringur'|'sporaskja', R (circle radius, default min(W, H) / 2) }.
   * malmRammi(W, H, g): the engraved 0.5 mm band of steel and brass, 3 mm in, g = { inset (3), band (0.5) }:
   *   RAMMI-LARETT top and bottom over the full width, RAMMI-LODRETT-90 the sides between them.
   * rammiLysing(g): the header line ['Rammi', text] for the file's lysing; g = null or { gerd: null } is
   *   "an" (no frame), g.gerd 'lina' or 'malmur' with the same numbers as above. */
  function t3(n) { return Math.round(n * 1000) / 1000; }
  function linuRammi(Wd, H, g) {
    g = g || {};
    var i = tala(g.inset) ? g.inset : 3, iy = tala(g.insetY) ? g.insetY : i, form = g.form || 'rett';
    if (form === 'hringur') { var R = tala(g.R) ? g.R : Math.min(Wd, H) / 2; return { gerd: 'hringur', lag: 'LINA', cx: t3(Wd / 2), cy: t3(H / 2), r: t3(R - i) }; }
    if (form === 'sporaskja') return { gerd: 'sporaskja', lag: 'LINA', cx: t3(Wd / 2), cy: t3(H / 2), rx: t3(Wd / 2 - i), ry: t3(H / 2 - iy) };
    return { gerd: 'rett', lag: 'LINA', x: t3(i), y: t3(iy), w: t3(Wd - 2 * i), h: t3(H - 2 * iy), r: t3(Math.max(0, (tala(g.r) ? g.r : 0) - i)) };
  }
  function malmRammi(Wd, H, g) {
    g = g || {};
    var i = tala(g.inset) ? g.inset : 3, b = tala(g.band) ? g.band : 0.5;
    return [
      { gerd: 'rett', lag: 'RAMMI-LARETT', x: t3(i), y: t3(i), w: t3(Wd - 2 * i), h: t3(b), r: 0 },
      { gerd: 'rett', lag: 'RAMMI-LARETT', x: t3(i), y: t3(H - i - b), w: t3(Wd - 2 * i), h: t3(b), r: 0 },
      { gerd: 'rett', lag: 'RAMMI-LODRETT-90', x: t3(i), y: t3(i + b), w: t3(b), h: t3(H - 2 * i - 2 * b), r: 0 },
      { gerd: 'rett', lag: 'RAMMI-LODRETT-90', x: t3(Wd - i - b), y: t3(i + b), w: t3(b), h: t3(H - 2 * i - 2 * b), r: 0 }
    ];
  }
  function mmTexti(n) { return String(t3(n)).replace('.', ','); }
  function rammiLysing(g) {
    if (!g || !g.gerd) return ['Rammi', '\u00c1n ramma'];
    if (g.gerd === 'malmur') return ['Rammi', 'Me\u00f0 ramma (RAMMI-LARETT 0\u00b0, RAMMI-LODRETT-90 90\u00b0)'];
    var i = tala(g.inset) ? g.inset : 3, iy = tala(g.insetY) ? g.insetY : i;
    return ['Rammi', 'Me\u00f0 ramma (LINA ' + mmTexti(i) + (iy !== i ? ' x ' + mmTexti(iy) : '') + ' mm)'];
  }

  W.SMFram = {
    utgafa: UTGAFA,
    lyklar: { skra: SKRA_LYKILL, json: JSON_LYKILL, nr: NR_LYKILL },
    snid: SNID,
    bua: bua,
    baetaVid: baetaVid,
    senda: senda,
    baetaOgSenda: baetaOgSenda,
    fraJson: fraJson,
    getur: getur,
    forhlada: forhlada,
    json: json,
    nafnSkrar: nafnSkrar,
    ascii: ascii,
    leturFyrir: leturFyrir,
    leturISpec: leturISpec,
    hefurLetur: hefurLetur,
    skraLetur: skraLetur,
    letur: function () { var o = {}; for (var k in LETUR) if (LETUR.hasOwnProperty(k)) o[k] = { nafn: LETUR[k].f, thykkt: LETUR[k].w, skaletrad: !!LETUR[k].i, uppruni: LETUR[k].u, skra: LETUR[k].skra, virkt: hefurLetur(k) }; return o; },
    fylki: fylki,
    margfalda: mul,
    /* element constructors (plain objects, JSON safe) */
    texti: function (texti, letur, mm, x, y, o) { var e = { gerd: 'texti', lag: 'GRAFA', texti: texti, letur: letur, mm: mm, x: x, y: y }; for (var k in (o || {})) if (o.hasOwnProperty(k)) e[k] = o[k]; return e; },
    rett: function (x, y, w, h, r, lag) { return { gerd: 'rett', lag: lag || 'SKERA-YTRA', x: x, y: y, w: w, h: h, r: r || 0 }; },
    rammi: function (x, y, w, h, r) { return { gerd: 'rett', lag: 'LINA', x: x, y: y, w: w, h: h, r: r || 0 }; },
    linuRammi: linuRammi,
    malmRammi: malmRammi,
    rammiLysing: rammiLysing,
    hringur: function (cx, cy, r, lag) { return { gerd: 'hringur', lag: lag || 'SKERA-YTRA', cx: cx, cy: cy, r: r }; },
    gat: function (cx, cy, r) { return { gerd: 'hringur', lag: 'SKERA-INNRA', cx: cx, cy: cy, r: r }; },
    sporaskja: function (cx, cy, rx, ry, lag) { return { gerd: 'sporaskja', lag: lag || 'SKERA-YTRA', cx: cx, cy: cy, rx: rx, ry: ry }; },
    slod: function (d, lag, m) { var e = { gerd: 'slod', lag: lag || 'GRAFA', d: d }; if (m) e.fylki = m; return e; },
    mynd: function (src, x, y, w, h, nafn) { return { gerd: 'mynd', lag: 'GRAFA-MYND', src: src, x: x, y: y, w: w, h: h, nafn: nafn || 'mynd' }; },
    /* path helpers (d strings in mm) */
    dRett: function (x, y, w, h, r) { return cmdsTilDAbs(cmdsRett(x, y, w, h, r || 0, r || 0)); },
    dHringur: function (cx, cy, r) { return cmdsTilDAbs(cmdsSporaskja(cx, cy, r, r)); },
    dSporaskja: function (cx, cy, rx, ry) { return cmdsTilDAbs(cmdsSporaskja(cx, cy, rx, ry)); },
    /* CW 19.10: the paw U+1F43E (see loppaGlyf); vafri() adds it to the web fonts on the page again (after new faces) */
    loppa: { glyf: loppaGlyf, ttf: loppaTtf, hlutfall: loppaHlutfall, vafri: loppaVafri },
    _innri: { lesaD: lesaD, flatten: flatten, cmdsTilD: cmdsTilDAbs, dSkra: cmdsTilD, uppsetning: function (id, t) { return hladaLetur(id).then(function (L) { return uppsetning(L, t); }); } }
  };
})(typeof window !== 'undefined' ? window : null, typeof document !== 'undefined' ? document : null);
